// vim: ai:ts=4:sw=4:et

'use strict';

const undefined = void 0;
const { window } = Function('return this')();
const {
    top, document, navigator, setTimeout, alert, location, clearTimeout, open, JSON,
    Blob, URL, console, requestAnimationFrame,
    fetch, Request, Headers, DOMParser, Promise,
    $: _$, jQuery, moment, history, decodeURIComponent, encodeURIComponent, Math,
} = window;
const { parse, stringify } = JSON
const { max, ceil, random } = Math;
const $ = jQuery || _$ || noop;

const pubdb = window.pubdb = window.pubdb || {};


if (pubdb.base_href == null) {
    pubdb.base_href = 'https://bib.vetmed.fu-berlin.de';
}
if (pubdb.path_root == null) {
    pubdb.path_root = pubdb.base_href + '/pubdb';
}
if (pubdb.no_content_only == null) {
    pubdb.no_content_only = null;
}
if (pubdb.lang == null) {
    pubdb.lang = '';
}

pubdb.path_static = (
    (document.currentScript || document.querySelector('script[src$="pubdb.js"]') || {}).src || ''
).replace(/\/javascript\/(?:[^/.-]+-)?pubdb\.js$/, '') || pubdb.path_root + '/S/_';


const {
    lang, base_href, path_root, path_static, login_details,
} = pubdb;

/* *****************************************************************************
* PRESERVE CLOBBERED VARIABLES
*******************************************************************************/

var fn_tooltip = ($ && $.fn && $.fn.tooltip) || noop;

/* *****************************************************************************
* HELPER FUNCTIONS
*******************************************************************************/

function noop () {}


const { hasOwnProperty } = {};


let next_tick_queue;

function next_tick (cb) {
    if (typeof cb !== 'function') {
        return;
    }

    if (next_tick_queue) {
        next_tick_queue.push(cb);
        return;
    }
    next_tick_queue = [cb];

    requestAnimationFrame(function () {
        const queue = next_tick_queue;
        next_tick_queue = null;

        const { length } = queue;
        for (let index = 0; index < length; ++index) {
            try {
                // rationale for storing in variable: queue must not be `this` in `cb()`
                const cb = queue[index];
                cb();
            } catch (ex) {
                console.log('Exception in next_tick', ex);
            }
        }
    });
}


function debounce (func, wait) {
    let timeout;
    return function () {
        const self = this;
        const args = [].slice.call(arguments);
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            timeout = null;
            func.apply(self, args);
        }, wait);
    };
}


function map (arr, cb) {
    return arr ? [].map.call(arr, cb) : [];
}

function indexOf (arr, item) {
    return arr ? [].indexOf.call(arr, item) : -1;
}


var __hasRole_memo = Object.create(null);

function hasRole (role) {
    let result = __hasRole_memo[role];
    if (result == null) {
        result = login_details && (indexOf(login_details.role, role) >= 0);
        __hasRole_memo[role] = result;
    }
    return result;
}


function trim (s) {
    return s ? ('' + s).trim() : '';
}

function extend (obj) {
    for (let args = arguments, i = 1, {length} = args; i < length; ++i) {
        const arg = args[i];
        for (let k in arg) {
            if (hasOwnProperty.call(arg, k)) {
                obj[k] = arg[k];
            }
        }
    }
    return obj;
}

function copy_obj (obj) {
    return extend({}, obj);
}

function foreach_key (obj, cb) {
    for (let k in obj) {
        if (hasOwnProperty.call(obj, k)) {
            if (cb.call(obj, k) === false) {
                return false;
            }
        }
    }
    return true;
}

function list_keys (obj, result) {
    if (result == null) {
        result = [];
    }
    foreach_key(obj, function (k) {
        result.push(k);
    });
    return result;
}

function list_values (obj, result) {
    if (result == null) {
        result = [];
    }
    foreach_key(obj, function (k) {
        result.push([k, obj[k]]);
    });
    return result;
}

function sort_by_key (arr, key, fun, reversed) {
    fun = fun || function (a, b) {
        return a > b ? +1 :
               a < b ? -1 : 0;
    };
    var sort = reversed ? function (a, b) {
        return fun(b[key], a[key]);
    } : function (a, b) {
        return fun(a[key], b[key]);
    };
    [].sort.call(arr, sort);
    return arr;
}

function get_nice_publication_type_name(type, singular) {
    return mustache(
        singular ? DISPLAY_PUBLICATION_TYPE_NAME_SINGLULAR : DISPLAY_PUBLICATION_TYPE_NAME,
        { type:type },
    );
}

function activate_tooltips (dest, container, add_right) {
    var offset_parent = $(container || '#PubDB, #content').eq(0);
    if (add_right == null) {
        add_right = 15;
    }
    if (offset_parent.length) {
        const tooltip = fn_tooltip.call(dest, {
            position: 'center right',
            offset: [0, 0],
            effect: 'fade',
            api: true,
            onBeforeShow (ev) {
                const { top, left } = offset_parent.offset();
                const { offset } = tooltip.getConf();
                offset[0] = -top;
                offset[1] = -left + add_right;
            },
        });
        return dest;
    }
}

function iframe_dialog (src, title, onload_cb, onunload_cb) {
    var iframe = $('<iframe/>').attr({src});

    var cW;
    iframe.one('load', function() {
        cW = iframe.get(0).contentWindow;
        cW.$(onload);
    });

    function onload(ev) {
        cW.$('#menu').hide();
        if(typeof onload_cb === 'function') {
            onload_cb.call(iframe, cW, ev);
        }
        cW.$(cW).on('beforeunload unload', onclose);
    }

    var unloaded = false;
    function onclose(ev, ui) {
        if (unloaded) {
            return;
        }
        unloaded = true;

        if (typeof onunload_cb === 'function') {
            if (onunload_cb.call(iframe, cW, ev) === false) {
                iframe.one('load', function() {
                    cW = iframe.get(0).contentWindow;
                    cW.$(onload);
                });
                return;
            }
        }

        next_tick(function () {
            iframe.dialog('close');
        });

        iframe.detach();
    }

    iframe.dialog({
        height: 640,
        width: 960,
        modal: true,
        resizable: false,
        dragable: true,
        title,
        close: onclose
    });
    iframe.css({
        width: '100%',
        padding: 0,
        margin: 0
    });

    iframe[0].scrollIntoView();
    return iframe;
}

function make_datepicker(dest, type) {
    $(dest)[type || 'datepicker']({
        dateFormat: 'dd.mm.yy',
        separator: ' ',
        timeFormat: 'hh:mm',
        yearRange: '2000:' + String((new Date).getFullYear() + 10),
        changeYear: true,
        changeMonth: true,
        showWeek: true,
        firstDay: 1,

        closeText: 'OK',
        prevText: '< zurück',
        nextText: 'vor >',
        currentText: 'heute',
        monthNames: ['Januar','Februar','März','April','Mai','Juni',
                'Juli','August','September','Oktober','November','Dezember'],
        monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun',
                'Jul','Aug','Sep','Okt','Nov','Dez'],
        dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
        dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        weekHeader: 'Wo',
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',

        timeText: 'Uhrzeit',
        hourText: 'Stunde',
        minuteText: 'Minute',
        secondText: 'Sekunde',

        onSelect: function (val, inst) {
            if (val !== inst.lastVal){
                $(this).change();
            }
        }
    });
}

function add_html_tooltip (dest, html, container, img) {
    dest = $(dest);

    const questionmark = $('<img/>', {
        attr: {
            src: img || `${base_href}/static/icons/gnome/colors-common/16x16/status/dialog-question.png`,
            style: 'margin-left:1rem',
        },
        appendTo: dest,
    });
    const hover = $('<div/>', {
        html,
        attr: {
            class: 'tooltip',
            style: 'font-size:1.35rem;line-height:1.5rem;',
        },
        appendTo: dest,
    });

    dest.data('pubdb-tooltip', { questionmark, hover });

    activate_tooltips(questionmark, container);

    return questionmark;
}

function add_tooltip (dest, text, container, img) {
    var html = document.createTextNode(text);
    return add_html_tooltip(dest, html, container, img);
}

function get_first_words (str, count) {
    var words = str.split(/\s+/);
    if (words.length > count) {
        words = words.slice(0, count);
        str = words.join(" ") + " […]";
    }
    return str;
}

function relogin () {
    var submitted = false;

    function loaded (cW, ev) {
        if (!submitted) {
            cW.pubdb.echo('warn', 'Sie wurden zwischenzeitlich abgemeldet. ' +
                                                        'Bitte geben Sie Ihre Anmeldedaten erneut ein!')
            return;
        }

        if (/\/login\/$/.exec(cW.location.pathname)) {
            echo('warn', 'Einloggen fehlgeschlagen.');
        } else {
            get_csrf_token(function (err, data) {
                if (err) {
                    echo('warn', 'Einloggen fehlgeschlagen.');
                } else {
                    echo('confirm', 'Sie wurden wieder eingeloggt. Bitte führen Sie die letzte Aktion erneut durch.');
                    $(':input[name=csrf_token]').val(data);
                    pubdb.csrf_token = data.data;
                }
            }, true);
        }
        this.dialog('close');
    }

    function unloading (cW, ev) {
        if (!submitted) {
            submitted = true;
            return false;
        } else {
            return true;
        }
    }

    return iframe_dialog(path_root + '/login/?content_only', 'Erneut anmelden', loaded, unloading);
}

function get_csrf_token (callback, silent) {
    function success (data) {
        if (!data.success) {
            if ('login_required' in data.errors) {
                relogin();
            } else {
                echo_errors(data.errors);
            }
        } else if (callback) {
            callback(null, data.data);
        } else {
            if (!silent) {
                echo('confirm', 'Eine neue Sitzungkennung wurde generiert. Bitte führen Sie die letzte Aktion erneut durch.');
            }
            $('input[name=csrf_token]').val(data.data);
            pubdb.csrf_token = data.data;
        }
    }

    function error (data, err, xhr) {
        if (callback) {
            callback(err, data);
        } else {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        }
    }

    if (!silent) {
        echo('warn', 'Sie haben zu lange keine Aktion durchgeführt. Ihre Sitzung ist deshalb abgelaufen.');
    }
    ajax_post(path_root + '/csrf_token/', null, success, error);
}

function read_form_data ({ form, data, visible_only, include_hidden, values_only }) {
    form = $(form || 'form');
    if (data == null) {
        data = {};
    }
    if (visible_only == null) {
        visible_only = false;
    }
    if (include_hidden == null) {
        include_hidden = !visible_only;
    }
    if (values_only == null) {
        values_only = false;
    }

    const selector_visible = visible_only ? ':visible' : '';

    function add_value (name, item) {
        const val = item.eq(0).val() || '';
        if (val || !values_only) {
            data[name] = val;
        } else {
            delete data[name]
        }
    }

    function add_checked (name, items) {
        for (let i = 0, l = items.length; i < l; ++i) {
            delete data[`${name}[${i}]`];
        }

        let checked = items.filter(':checked');
        for (let i = 0, l = checked.length; i < l; ++i) {
            data[`${name}[${i}]`] = checked[i].value;
        }
    }

    $(
        [].concat(
            ['input[name]:not(' + ['button', 'checkbox', 'file', 'hidden', 'image', 'radio', 'reset', 'submit'].map(s => `[type=${s}]`).join(',') + ')' + selector_visible],
            ['textarea[name]' + selector_visible],
            include_hidden ? 'input[name][type=hidden]' : [],
        ).join(','),
        form,
    ).each(function () {
        const self = $(this);
        add_value(self.attr('name'), self);
    });

    $('select[name]'  + selector_visible, form).each(function () {
        const self = $(this);
        const name = self.attr('name');
        const options = $('option', self);
        if (!self.is('[multiple]')) {
            add_value(name, options.filter(':selected'));
        } else {
            add_checked(name, options);
        }
    });

    group($('input[name][type=radio][value][value!=""]' + selector_visible, form), 'name', '', 'name').forEach(({name, items}) => {
        if (!name) {
            return;
        }

        delete data[name];

        let checked = $(items).filter(':checked');
        if (checked.length) {
            data[name] = checked[0].value;
        } else {
            delete data[name];
        }
    });

    group($('input[name][type=checkbox][value][value!=""]' + selector_visible, form), 'name', '', 'name').forEach(({name, items}) => {
        add_checked(name, $(items));
    });

    return data;
}

function encodeBooleanSearch (q) {
    // http://dev.mysql.com/doc/refman/5.5/en/fulltext-boolean.html
    // http://dev.mysql.com/doc/refman/5.1/de/fulltext-boolean.html

    q = trim(q.replace(/[\0-\x1f\x7f\s]/g, ' ')); // replace all whitespaces with space

    // escape all "..."
    var literals = {};
    q = q.replace(/\".*?\"/g, function (literal) {
        do {
            var name = '\x01' + ((random() * 1e8)|0) + '\x02';
        } while (name in literals);
        literals[name] = literal;
        return ' ' + name + ' ';
    });

    q = q.replace(/\s+(http|ftp)s?(:\/*|\/+)/ig, ' '); // why would someone put an HTTP URL?
    q = q.replace(/[\^!\$%&\/\[\]\{\}#_\.:,;\<\>\|\\~`´]+/g, ' '); // replace some noisy characters
    q = q.replace(/(\d)-(\d)/g, '$1$2'); // omit inner hyphens between digits (ISBNs, ISSNs)
    q = q.replace(/\*(\S)/g, ' $1'); // replace asterisks if not end of word
    q = q.replace(/(\S)-/g, '$1 '); // replace hyphen if not start of word
    q = trim(q); // trim again
    q = q.replace(/\s+([+-])\s+/g, ' $1'); // omit spaces before second word if there is a junctor in between
    q = q.replace(/\s+/g, ' '); // squash multiple spaces
    q = q.replace(/\s+(?![+-])/g, ' +'); // make AND default junctor
    q = q.replace(/\s*[+-]+\s*$/g, ''); // trailing junctors
    q = q.replace(/^([^+-])/, '+$1'); // add leading AND

    // re-insert "..."
    q = q.replace(/\x01\d+\x02/g, function (name) {
        return literals[name];
    });

    return q;
}

var _has_role_cache = {};
function has_role (role) {
    if (!login_details) {
        return false;
    }

    var result = _has_role_cache[role];
    if (result ==/*sic*/ null) {
        result = false;
        for (var l = login_details.role, i = 0, len = l.length; i < len; ++i) {
            if (l[i] === role) {
                result = true;
                break;
            }
        }
        _has_role_cache[role] = result;
    }
    return result;
}

function confirm (title, text, button_list, text_fun) {
    let self = $('<div/>')[text_fun || 'text'](text);

    function close () {
        try {
            self.dialog('close');
        } finally {
            self.remove();
        }
    }

    let buttons = {};
    for (let i = 0, {length} = button_list; i < length; ++i) {
        let [title, fn] = button_list[i];
        buttons[title] = (function (callback) {
            return function () {
                next_tick(callback);
                close();
            };
        })(fn);
    }

    next_tick(function () {
        self.dialog({
            modal: true,
            width: 800,
            title: title,
            buttons: buttons
        });
    });

    return {
        dialog: self,
        buttons: buttons
    };
}

function multi_prompt (title, text, label_dflt, button_list, text_fun) {
    var inputs = [];
    var labels = map(label_dflt, ({label, dflt, type}) => {
        var input = $('<input/>', {
            style: 'border: 1px solid #aaa; padding: 2px;',
            type: type || 'text',
            val: dflt || '',
        });
        inputs.push(input);
        return $('<p/>', {
            append: $('<label/>', {
                text: label,
                append: ['\xA0', input]
            }),
        });
    });
    labels.unshift($('<p/>')[text_fun || 'text'](text));

    setTimeout(function () {
        inputs[0].select();
    }, 18);

    var body = $('<form/>', {
        on: {
            submit: function () {
                next_tick(function () {
                    result.buttons[button_list[0][0]]();
                });
                return false;
            }
        },
        append: labels,
    });
    button_list = map(button_list, function (button) {
        function callback () {
            if (!button[1]) {
                return;
            }
            button[1].apply(null, map(inputs, input => input.val()));
        }
        return [button[0], callback];
    });

    var result = confirm(title, body, button_list, 'html');
    result.inputs = inputs;
    return result;
}

function prompt (title, text, label, dflt, button_list, text_fun) {
    var result = multi_prompt(title, text, [{label, dflt}], button_list, text_fun);
    result.input = result.inputs[0];
    return result;
}

function range (start, end, step) {
    if (end == null) {
        end = start;
        start = 0;
        step = 1;
    } else if (!step) {
        step = 1;
    }

    const result = Array(ceil((end - start) / step));
    for (let v = start, i = 0; v < end; v += step, ++i) {
        result[i] = v;
    }
    return result;
}

function date_berlin (as_string, input) {
    const result = moment.tz(input, 'Europe/Berlin');
    if (as_string) {
        return result.format('DD.MM.YYYY, HH:mm:ss (z)');
    } else {
        return result;
    }
}

function resizable_dialog (inner_elem, options) {
    const elem = $('<div/>', {
        class: 'PubDB',
        append: inner_elem,
        appendTo: '#PubDB-Body',
        dialog: options || {},
    });

    const dialog = elem.data('dialog');
    const ui = dialog.element.closest('.ui-dialog');
    ui.css('visibility', 'hidden');

    const STATE_NORMAL = 0;
    const STATE_MINI = 1;
    const STATE_MAXI = 2;

    elem.on('dialogresize dialogresizestop', function (ev, ui) {
        restore_elem();
    });

    function restore_elem () {
        elem.css({
            display: 'inline-block',
            width: '100%',
            height: 'calc(100% - 40px)',
            maxWidth: 'unset',
            maxHeight: 'unset',
            minWidth: 'unset',
            minHeight: 'unset',
            padding: '0 2pt 2pt 2pt',
            overflow: 'scroll',
        });
    }

    function minimize () {
        dialog.element.hide();
        ui.css({
            position: 'fixed',
            left: 'unset',
            right: '0',
            top: 'unset',
            bottom: '0',
            width: '400px',
            height: 'unset',
        });
        elem.dialog('option', 'resizable', false);
        elem.dialog('option', 'draggable', false);
    }

    function maximize () {
        const ui = dialog.element.closest('.ui-dialog');
        ui.css({
            position: 'fixed',
            left: '0',
            right: '0',
            top: '0',
            bottom: '0',
            width: 'unset',
            height: 'unset',
        });
        elem.dialog('option', 'resizable', false);
        elem.dialog('option', 'draggable', false);
    }

    function restore () {
        restore_elem();
        ui.css({
            position: 'unset',
            left: 'unset',
            right: 'unset',
            top: 'unset',
            bottom: 'unset',
            minHeight: 'unset',
            width, height,
        });
        elem.dialog('option', 'resizable', true);
        elem.dialog('option', 'draggable', true);
        elem.dialog('option', 'position', { at: 'center' });
    }

    function new_btn (icon, text, click) {
        return $('<a>', {
            attr: {
                class: 'ui-state-default ui-corner-all',
                href: 'javascript:;',
                role: 'button',
                style: 'float:right; padding:2pt',
            },
            append: $('<span>', {
                attr: { class: 'ui-icon ui-icon-' + icon },
                text,
            }),
            on: { click },
            insertAfter: btn_close_orig,
        });
    }

    let state = -1;
    let width, height;

    function set_state (ev, code, fun) {
        if (ev) {
            ev.preventDefault();
        }

        if (state !== STATE_NORMAL) {
            restore();
        } else {
            width = ui.css('width');
            height = ui.css('height');
        }

        if (state !== code) {
            state = code;
            fun();
        } else {
            state = STATE_NORMAL;
        }
    }

    let btn_close_orig = $('.ui-dialog-titlebar-close', dialog.uiDialogTitlebar);
    let btn_minimize = new_btn('minusthick', 'minimieren', function (ev) {
        set_state(ev, STATE_MINI, minimize);
    });
    let btn_maximize = new_btn('arrowthick-2-se-nw', 'maximieren', function (ev) {
        set_state(ev, STATE_MAXI, maximize);
    });
    let btn_close = new_btn('closethick', 'schließen', function (ev) {
        ev.preventDefault();
        elem.dialog('close');
    });
    btn_close_orig.remove();

    next_tick(function () {
        width = ui.css('width');
        height = ui.css('height');
        set_state(null, STATE_MINI, minimize);
        ui.css('visibility', 'unset');
    });
}


/* *****************************************************************************
* FLASK GLUE
*******************************************************************************/


let echo_dest;
const ECHO_HIDE_DELAY = 10000;

function echo(type, msg) {
    let hiding = false;
    const li = $('<li/>', {
        text: msg,
        prepend: $('<img/>', {
            attr: {
                src: (
                    base_href + '/static/icons/gnome/colors-common/22x22/status/dialog-' +
                    (type === 'confirm' ? 'information' : 'warning') +
                    '.png'
                ),
                style: 'padding-right: 1ex',
            },
        }),
        attr: {
            class: type === 'confirm' ? 'confirm' : 'warn',
        },
        on: {
            click (ev) {
                if (hiding) {
                    return;
                }
                hiding = true;
                li.stop(true, true).slideUp('medium', function() {
                    li.detach();
                });
            },
        },
        appendTo: echo_dest || '#echo',
        slideDown: 'medium',
    });
    setTimeout(function () {
        if (hiding) {
            return;
        }
        hiding = true;
        li.slideUp('slow', function() {
            li.detach();
        });
    }, ECHO_HIDE_DELAY);
    return li;
}


let ajax_requests = 0;

function chng_ajax_wait (amount) {
    ajax_requests += amount;
    if (ajax_requests < 0) {
        ajax_requests = 0;
    }

    if (ajax_requests > 0) {
        $('#PubDB').addClass('wait');
    } else {
        $('#PubDB').removeClass('wait');
    }
}

function incr_ajax_wait (amount, quiet) {
    if (amount && !quiet) {
        chng_ajax_wait(+amount);
    }
}

function decr_ajax_wait (amount, quiet) {
    if (amount && !quiet) {
        chng_ajax_wait(-amount);
    }
}

function ajax (method, body, url, success, error, quiet) {
    const init = {
        method,
        headers: new Headers({ 'X-Requested-With': 'XMLHttpRequest' }),
        mode: 'cors',
        credentials: 'include',
        cache: 'no-cache',
        redirect: 'follow',
        referrerPolicy: 'no-referrer-when-downgrade',
    };
    if (method === 'POST') {
        init.headers.set('Content-Type', 'application/json; charset=utf-8');
        init.body = body;
    }

    const req = new Request(url, init);
    incr_ajax_wait(1, quiet);
    return (
        fetch(req).
        then(response => {
            if (response.ok) {
                const mimetype = (response.headers.get('Content-Type') || '').split(',', 1)[0].split(';', 1)[0].split('/', 2)[1];
                let promise;
                if (mimetype === 'json') {
                    promise = response.json();
                } else {
                    promise = response.text();
                    if (mimetype === 'xml') {
                        promise = promise.then(content => new DOMParser().parseFromString(content, 'text/xml'));
                    } else if (mimetype === 'text') {
                        promise = promise.then(content => new DOMParser().parseFromString(content, 'text/html'));
                    }
                }
                return promise.then(content => {
                    if (success) {
                        success(content);
                    }
                });
            } else {
                console.log('Fetch not ok', response);
                if (error) {
                    error({ statusText: response.statusText });
                }
            }
        }).
        catch(ex => {
            console.log('Ajax exception', ex);
            if (error) {
                error({ statusText: ex });
            }
        }).
        finally(() => {
            decr_ajax_wait(1, quiet);
        })
    );
}

function ajax_post(url, data, success, error, quiet) {
    return ajax('POST', stringify(data), url, success, error, quiet);
}

function ajax_get(url, success, error, quiet) {
    return ajax('GET', null, url, success, error, quiet);
}

function status_call (id, data, fn) {
    if (!fn) {
        fn = noop;
    }
    function cb (response) {
        try {
            let { csrf_token } = response || {};
            if (csrf_token) {
                delete response.csrf_token;
                pubdb.csrf_token = csrf_token;
            }
        } catch (ex) {
            console.log('Supressed exception', ex);
        }
        console.log('<<', id, response);
        fn(response);
    }

    console.log('>>', id, data);
    return ajax_post(
        `${path_root}/pub/${id}/status/`,
        { csrf_token: pubdb.csrf_token, data },
        cb,
        cb,
    );
}

function status_call1 (id, op, args, fn) {
    if (!fn) {
        fn = noop;
    }
    function cb (response) {
        var { success, data, reason } = response || {};
        if (!success) {
            fn(false, reason || 'Unbekannter Fehler');
            return;
        }

        var [data] = data || [];
        var { success, data, reason } = data || {};
        if (!success) {
            fn(false, reason || 'Unbekannter Fehler');
            return;
        }

        fn(true, data);
    }
    return status_call(id, [{op, args}], cb);
}

function status_ping (fn) {
    const rnd = (random() * 0x7ffffff) | 0;

    function got_pong (success, reason_or_data) {
        if (!success) {
            fn(false, reason_or_data);
        } else if (reason_or_data !== rnd) {
            fn(false, 'Ping-Pong fehlgeschlagen');
        } else {
            fn(true);
        }
    }

    return status_call1(0, 'ping', [rnd], got_pong);
}

function status_otf (get_triple, got_result, err_msg) {
    if (err_msg == null) {
        err_msg = 'On-the-fly-Speicherung nicht möglich';
    }

    function got_pong (success, reason) {
        if (!success) {
            echo('warn', err_msg + ': ' + reason);
            return;
        }

        $('#edit_table+div').html($('<button>', {
            type: 'button',
            append: $('<img>', {
                attr: {
                    src: base_href + '/static/icons/tango/0.8.90/scalable/actions/view-refresh.svg',
                    style: 'height:3rem;width:3rem',
                    alt: 'neuladen',
                    title: 'neuladen',
                }
            }),
            on: {
                click (ev) {
                    ev.preventDefault();

                    const nocache = 'nocache=' + (+new Date) + '.' + (random() * 0x7ffffff);
                    let [, search] = without_nocache(location.search);
                    if (search) {
                        location.search = search + '&' + nocache;
                    } else {
                        location.search = '?' + nocache;
                    }
                },
            },
        }));
        $('#pubdb_data').on('click change', '[type=checkbox], [type=radio]', onclick);

        echo('confirm', 'Änderungen werden sofort übernommen.');
    }

    let status_otf_ignore = 0;

    function onclick (ev) {
        if (status_otf_ignore) {
            return;
        }

        let cb, shall_check, isa_checkbox;
        if (this.type === 'checkbox') {
            cb = $(this);
            shall_check = cb.prop('checked');
            isa_checkbox = true;
        } else if (this.type === 'radio') {
            cb = $(this).closest('tr,form,body').find(`[name="${this.name}"]`);
            shall_check = cb.filter(':checked');
        } else {
            return;
        }

        const triple = get_triple(cb, shall_check);
        if (!triple) {
            return;
        }
        const [ pub_id, op, args ] = triple;

        ++status_otf_ignore;
        next_tick(function () { --status_otf_ignore; });
        ev.preventDefault();

        cb.prop('readonly', true);
        cb.prop('disabled', true);

        function got_answer (success, data) {
            try {
                if (!success) {
                    echo('warn', err_msg + ': ' + data);
                } else {
                    ++status_otf_ignore;
                    next_tick(function () { --status_otf_ignore; });

                    if (isa_checkbox) {
                        cb.prop('checked', shall_check);
                    } else {
                        shall_check.prop('checked', true);
                    }

                    if (got_result) {
                        got_result(cb, shall_check, data);
                    }
                }
            } finally {
                cb.prop('readonly', false);
                cb.prop('disabled', false);
            }
        }

        status_call1(pub_id, op, args, got_answer);
    }

    return status_ping(display_when_ready(got_pong));
}

function add_toggle_diff (tr, colors) {
    if (!colors) {
        return $(tr).on('click', '.-show-diff a', function (ev) {
            ev.preventDefault();
            var self = $(this);
            toggle_diff(self.closest('tr'), self.data('func'));
        });
    }

    const { diffWordsWithSpace, diffChars, diffSentences, diffTrimmedLines } = window.JsDiff || {};

    tr = $(tr);
    var tds = tr.children('td');
    if (tds[0].innerText === tds[1].innerText) {
        return false;
    }

    var th = $('>th', tr).addClass('-show-diff');
    $('>td', tr).css('background-color', colors[1 & +tr.data('num')]);

    $('<p>', {
        append: [
            $('<a>', {
                href: 'javascript:;',
                text: '[W]',
                title: 'Unterschiedliche Wörter.',
                data: { func: diffWordsWithSpace },
                css: { padding: '0 0.25ex' }
            }),
            $('<a>', {
                href: 'javascript:;',
                text: '[B]',
                title: 'Unterschiedliche Buchstaben.',
                data: { func: diffChars },
                css: { padding: '0 0.25ex' }
            }),
            $('<a>', {
                href: 'javascript:;',
                text: '[S]',
                title: 'Unterschiedliche Sätze.',
                data: { func: diffSentences },
                css: { padding: '0 0.25ex' }
            }),
            $('<a>', {
                href: 'javascript:;',
                text: '[Z]',
                title: 'Unterschiedliche Zeilen.',
                data: { func: diffTrimmedLines },
                css: { padding: '0 0.25ex' }
            })
        ],
        appendTo: th,
    });

    return true;
}

function mark_erroneous (field) {
    return field.css({
        'box-shadow': '0 0 9px #a40000'
    }).one('change keyup', function (e) {
        if (typeof this.style.removeProperty === 'function') {
            this.style.removeProperty('box-shadow');
        } else {
            this.style.boxShadow = 'inherit';
        }
        $(this).data('is-invalid', false);
    }).data('is-invalid', true).focus();
}

function echo_errors (errors, form) {
    var found_error = false;
    errors = list_values(errors);
    if (form) {
        var form = $(form);
        var fields = {};
        $(':input[name]:visible', form).each(function (i, f) {
            fields[f.name] = fields[f.name] || i + 1;
        });
        errors.sort(function (a, b) {
            a = a[0];
            b = b[0];
            if (fields[a] && fields[b]) {
                return fields[a] - fields[b];
            } else if (!fields[a] && fields[b]) {
                return -1;
            } else if (fields[a] && !fields[b]) {
                return +1;
            } else {
                return 0;
            }
        });
    }
    for (var i = 0; i < errors.length; ++i) {
        var k = errors[i][0], v = errors[i][1];
        if (form) {
            if (!found_error) {
                var label = $('label[for="' + k + '"]', form).get(0);
                if (label) {
                    label.scrollIntoView();
                    found_error = true;
                }
            }
            mark_erroneous($(':input[name="' + k + '"]', form));
        }
        if (typeof v === 'string') {
            v = [v];
        }
        for (var j = 0; j < v.length; j++) {
            echo('warn', v[j]);
        }
    }
    return false;
}

const KEY_INVARIANTS = {
    xhr: '1',
    content_only: '1',
    status_only: '1',
};

function encode_uri_component (s) {
    return encodeURIComponent(s).replace(/[!'()*]/g, c => '%' + c.charCodeAt(0).toString(16));
}

function decode_uri_component (s) {
    return decodeURIComponent(s).replace(/[+]/g, ' ');
}

function parse_qsl (search, result) {
    if (result == null) {
        result = [];
    }
    if (search) {
        const pattern = /(?!$)(?:^[?]?|&)*([^&=]*)?(?:=([^&=]*))?/g;
        let m;
        while ( (m = pattern.exec(search)) ) {
            let [, key, value] = m;
            key = decode_uri_component(key);
            if (key in KEY_INVARIANTS) {
                value = KEY_INVARIANTS[key];
            } else {
                value = decode_uri_component(value);
            }
            result.push([key, value]);
        }
    }
    return result;
}

function parse_qs (search, result) {
    if (result == null) {
        result = {};
    }
    for (let kvs = parse_qsl(search), { length } = kvs, i = 0; i < length; ++i) {
        const [k, v] = kvs[i];
        result[k] = v;
    }
    return result;
}

function urlencode (query, parts) {
    if (parts == null) {
        parts = [];
    }
    if (query != null) {
        // rationale: {length} may be a legitimate key, so testing against is_arrayish() is not sane
        if ({}.toString.call(query) === '[object Array]') {
            for (let i = 0, { length } = query; i < length; ++i) {
                const [k,v] = query[i];
                if (k) {
                    parts.push(encode_uri_component(k) + '=' + encode_uri_component(v || ''));
                }
            }
        } else {
            foreach_key(query, k => {
                if (k) {
                    parts.push(encode_uri_component(k) + '=' + encode_uri_component(query[k] || ''));
                }
            });
        }
    }
    if (parts.length) {
        return '?' + parts.join('&');
    } else {
        return '';
    }
}


/* *****************************************************************************
* DISPLAYING HELPER FUNCTIONS
*******************************************************************************/


function groupToMap (items, key, dest, def_key_val, opts) {
    var buckets = group(items, key, def_key_val, 'key', opts);
    var result = dest || {};
    for (var i = 0, len = buckets.length; i < len; ++i) {
        var bucket = buckets[i];
        result[bucket.key] = bucket.items;
    }
    return result;
}

/**
 * \return [ { json_key: key_val, items:[...] } ]
 */
function group(items, key, def_key_val, json_key, opts) {
    opts = opts || {};
    var group_indices = [];
    var groups = {};
    $(items).each(function(_, item) {
        var item_key = item[key] || def_key_val;
        if(typeof opts.key_modify === 'function') {
            item_key = opts.key_modify(item_key);
        }
        if(typeof groups[item_key] !== 'undefined') {
            groups[item_key].items.push(item);
        } else {
            groups[item_key] = { items: [item] };
            groups[item_key][json_key] = item_key;
            group_indices.push(item_key);
        }
    });

    var result = [];
    for(var i = 0; i < group_indices.length; ++i) {
        result.push(groups[group_indices[i]]);
    }
    if(typeof opts.sort === 'function') {
        result = result.sort(opts.sort);
    }
    return result;
}

function sort_lastname (a, b) {
    var a = a.authors[0].lastname.split(/\s+/);
    a = a[a.length - 1];
    var b = b.authors[0].lastname.split(/\s+/);
    b = b[b.length - 1];
    return a === b ? 0 : a > b ? +1 : -1;
}

function find_in_stack (stack, keys, default_value) {
    if (keys) {
        const pivot = {};
        for (let i = 0, {length} = keys; i < length; ++i) {
            const result = lookup(keys[i], stack, pivot);
            if (result !== pivot) {
                return result;
            }
        }
    }
    return default_value ==/*sic*/ null ? '' : default_value;
}

function review_sortable (tbl, dont_ignore_leader) {
    if (!tbl) {
        tbl = $('#edit_table');
    }
    var opts;
    if (!dont_ignore_leader) {
        opts = {
            headers: { 0: { sorter: false } }
        };
    }

    tbl.tablesorter(opts).on('sortEnd', function (ev) {
        $('tr:not([hidden]) .index', tbl).each(function (index) {
            $(this).text(index + 1);
        });
    });
}

function review_filter_years (tbl, col) {
    var edit_table = tbl || $('#edit_table');
    var select_year = $('<select>', {
        append: $('<option value="0" selected autocomplete="off">— alle —</option>'),
        css: {
            width: 'unset',
            display: 'inline-block'
        },
        on: {
            change: function () {
                var display_year = +$(this).val();
                $('tr', edit_table).each(function () {
                    var tr = $(this);
                    var year = +$('td:nth-child(' + col + ')', tr).text();
                    if ((year|0) === year) {
                        if (display_year && year !== display_year) {
                            tr.attr('hidden', 'hidden');
                        } else {
                            tr.removeAttr('hidden');
                        }
                    }
                });
                edit_table.trigger('sortEnd');
            },
        },
    });
    var years = {};
    $('tr td:nth-child(' + col + ')', edit_table).each(function (i) {
        var year = +$(this).text();
        if ((year|0) === year) {
            years[year] = year;
        }
    });
    Object.keys(years).sort().reverse().forEach(function (year) {
        $('<option>', {
            text: year,
            value: year,
            appendTo: select_year
        });
    });
    $('<label>', {
        text: 'Jahr anzeigen: ',
        append: select_year,
        insertBefore: edit_table
    });
}

function kb_ev_cmp (ev, exp_which, exp_key) {
    if (ev) {
        const { which, keyCode, key } = ev;
        return (exp_key && (key === exp_key)) || ((which || keyCode) === exp_which);
    }
}

function kb_ev_enter (ev) {
    return kb_ev_up_down_enter(ev) === 'Enter';
}

const UP_DOWN_ENTER = {
    'Enter': 'Enter',
    'ArrowUp': 'ArrowUp',
    'ArrowDown': 'ArrowDown',
    10: 'Enter',
    13: 'Enter',
    38: 'ArrowUp',
    40: 'ArrowDown',
};
function kb_ev_up_down_enter (ev) {
    if (ev) {
        return UP_DOWN_ENTER[ev.key] || UP_DOWN_ENTER[ev.which] || UP_DOWN_ENTER[ev.keyCode];
    }
}

function ajax_success_handler (resp, field) {
    if (resp) {
        const { success } = resp;
        if (success) {
            return true;
        }

        const { errors } = resp;
        if (errors) {
            if ('login_required' in errors) {
                relogin();
            } else if ('csrf_token' in errors) {
                get_csrf_token();
            } else {
                echo_errors(errors);
            }
        }
    }
    return false;
}

function ajax_success_next_handler (resp, field) {
    if (!ajax_success_handler(resp)) {
        return false;
    }

    const { callback, callid } = pubdb;
    if (callback) {
        const data = field !== null ? resp[field || 'data'] : null;
        next_tick(function () {
            window[callback](data, callid);
        });
        return 'callback';
    } else {
        const { next } = resp;
        if (next) {
            next_tick(function () {
                location.href = next;
            });
            return 'next';
        }
        return 'success';
    }
}



/* *****************************************************************************
* DISPLAYING MARKUP
*******************************************************************************/


function DISPLAY_YEAR(view,partials,stack) {
    return mustache('{{getUTCFullYear}}', new Date(find_in_stack(stack, partials.args || ['datum', 'timestamp'])));
}

function DISPLAY_WHOLE_DATE(view,partials,stack) {
    var datum = find_in_stack(stack, partials.args || ['datum', 'timestamp']);
    var date = new Date(datum);
    var d = ''+date.getUTCDate();
    var m = ''+(1 + date.getUTCMonth());
    return (d[1]?'':'0')+d + '.' + (m[1]?'':'0')+m + '.' + date.getUTCFullYear();
}

function DISPLAY_WHOLE_TIME(view,partials,stack) {
    var date = new Date(find_in_stack(stack, partials.args || ['datum', 'timestamp', '.']));
    var m = ''+date.getUTCMinutes();
    var s = ''+date.getUTCSeconds();
    return date.getHours() + ':' + (m[1]?'':'0')+m + ':' + (s[1]?'':'0')+s;
}

function DISPLAY_BERLIN_TIMESTAMP(view,partials,stack) {
    return date_berlin(true, find_in_stack(stack, partials.args || ['datum', 'timestamp', '.']));
}

function DISPLAY_SEITEN_VON_BIS(view,partials,stack) {
    var seitenzahl = lookup('seitenzahl', stack, '');
    var seitenzahl_ende = lookup('seitenzahl_ende', stack, '');
    return escapeHTML(seitenzahl) + (seitenzahl_ende && seitenzahl !== seitenzahl_ende ? '–' + escapeHTML(seitenzahl_ende) : '');
}

function DISPLAY_URL(view,partials,stack) {
    var url = find_in_stack(stack, partials.args || ['url', '.'], '');
    if (!url) {
        return '';
    }
    var e = /^((?:https?|ftp):\/\/)/i.exec(url);
    var link = e ? url : 'http://' + url;
    var text = (e ? url.substring(e[1].length) : url).replace(/\/$/, '').replace(/[.,\/\-_#?:]+|\d+/ig, '$&\u200b');
    return mustache('<a href="{{link}}" rel="noopener">{{text}}</a>', { link, text });
}

function DISPLAY_ISSN (view,partials,stack) {
    var issn = find_in_stack(stack, partials.args || ['issn', '.'], '');
    if (!issn) {
        return '';
    } else if (issn.length === 8) {
        return issn.substr(0, 4) + '-' + issn.substr(4, 4);
    } else {
        return issn;
    }
}

function UPPER_QUOTE (view,partials,stack) {
    var datum = find_in_stack(stack, partials.args, '');
    if (!datum) {
        return '';
    } else {
        return escapeHTML(encode_uri_component(('' + datum).replace(/\./g, '').replace(/\s+/, ' ').toUpperCase()));
    }
}

function DISPLAY_KONGRESS_DURATION(view,partials,stack) {
    var begin = new Date(find_in_stack(stack, ['kongress_datum']));
    var end = new Date(find_in_stack(stack, ['kongress_ende']));
    if (!+end || begin === end) {
        var d = ''+begin.getUTCDate();
        var m = ''+(1 + begin.getUTCMonth());
        return (d[1]?'':'0')+d + '.' + (m[1]?'':'0')+m + '.' + begin.getUTCFullYear();
    } else {
        var d1 = ''+begin.getUTCDate();
        var m1 = ''+(1 + begin.getUTCMonth());
        var d2 = ''+end.getUTCDate();
        var m2 = ''+(1 + end.getUTCMonth());
        if (begin.getUTCFullYear() !== end.getUTCFullYear()) {
            return (d1[1]?'':'0')+d1 + '.' + (m1[1]?'':'0')+m1 + '.' + begin.getUTCFullYear() + '-' +
                   (d2[1]?'':'0')+d2 + '.' + (m2[1]?'':'0')+m2 + '.' + end.getUTCFullYear();
        } else /*if (m1 !== m2)*/ {
            return (d1[1]?'':'0')+d1 + '.' + (m1[1]?'':'0')+m1 + '.-' +
                   (d2[1]?'':'0')+d2 + '.' + (m2[1]?'':'0')+m2 + '.' + begin.getUTCFullYear();
        } /*else {
            return (d1[1]?'':'0')+d1 + '.-' + (d2[1]?'':'0')+d2 + '.' + (m2[1]?'':'0')+m2 + '.' + begin.getUTCFullYear();
        }*/
    }
}

function ESCAPE_DOUBLE_QUOTES_FOR_CSV (view,partials,stack) {
    var field = find_in_stack(stack, partials.args, '');
    if (!field) {
        return '';
    } else {
        return field.replace(/"/g, '""');
    }
}

var ESC_MOST_HTML = (function () {
    const _SAFE_TAGS = {
        i:   '</i>',
        sub: '</sub>',
        sup: '</sup>'
    };

    var _ESC_CHAR = Array(128);
    for (let c = 0; c < 128; ++c) {
        _ESC_CHAR[c] = String.fromCharCode(c);
    }
    _ESC_CHAR["'".charCodeAt(0)] = '&apos;'
    _ESC_CHAR['"'.charCodeAt(0)] = '&quot;'
    _ESC_CHAR['&'.charCodeAt(0)] = '&amp;'
    _ESC_CHAR['<'.charCodeAt(0)] = '&lt;'
    _ESC_CHAR['>'.charCodeAt(0)] = '&gt;'

    const _AMP = /^#?[A-Za-z0-9]+;/;

    const _URL_REGEX = new RegExp('\\b' +
                   /* scheme */ '((?:https?|ftps?)://)' +
                   /* cred */   '([^\\s@:#\/"\'&()?{\\[\\]}\\+,;|<>]+(?::[^\\s@:#/"\'&()?{\\[\\]}\\\\+,;|<>]*)?@)?' +
                   /* domain */ '((?:\\.?[^\\s!"$%&\/()=?`^{\\[\\]}\\+*#\',;:_|<>.]+)+)' +
                   /* port */   '(:[1-9]+[0-9]*)?' +
                   /* path */   '(/(?:\\.*[^\\s!"&()?`#\',;.|<>]+)*)?' +
                   /* query */  '(\\?(?:[.&]*[^\\s!"&()?`#\',;.|<>]+)*)?' +
                   /* frag */   '(#(?:[.&]*[^\\s!"&()?`#\',;.|<>]*)*)?',
                   'g');

    function _esc_most_html_sub (data, pos, l, result) {
        function append_c (dest) {
            var x = c.charCodeAt(0);
            if (x < 128) {
                    dest.push(_ESC_CHAR[x]);
            } else {
                dest.push(c);
            }
        }

        while (pos < l) {
            var c = data[pos];
            ++pos;

            if (c === '&') {
                var m = _AMP.exec(data.substring(pos, l));
                if (!m) {
                    result.push('&amp;');
                } else {
                    result.push(data.substr(pos-1, m[0].length + 1));
                    pos += m[0].length;
                }
                continue;
            }

            if (c !== '<' || !c) {
                append_c(result)
                continue;
            }

            var tag = [];
            var valid_xml = false;
            c = data[pos];
            ++pos;
            while (pos < l) {
                if ('a' <= c && c <= 'z') {
                    tag.push(c);
                } else {
                    if (c !== '>') {
                        append_c(tag);
                    } else {
                        valid_xml = true;
                    }
                    break;
                }
                c = data[pos]
                ++pos;
            }

            tag = tag.join('');
            if (!valid_xml) {
                result.push('&lt;', tag);
                continue
            }

            var safe_tag_end = _SAFE_TAGS[tag];
            if (!safe_tag_end) {
                result.push('&lt;', tag, '&gt;');
                continue;
            }

            var m = data.indexOf(safe_tag_end, pos);
            if (m <=/* SIC: we do not accept empty tags */ 0 || m >= l) {
                result.push('&lt;', tag, '&gt;');
                continue;
            }

            result.push('<', tag, '>');
            _esc_most_html_sub(data, pos, m, result);
            result.push(safe_tag_end);

            pos = m + safe_tag_end.length;
        }

        return result;
    }

    function _esc_most_html (view,partials,stack) {
        let field = find_in_stack(stack, partials.args, '');
        if (!field) {
            return '';
        }

        field = trim(field);
        if (!field) {
            return '';
        }

        field = field.replace(/[\x01\x02]+/g, ' ');

        // escape all links
        const urls = {};
        field = field.replace(_URL_REGEX, function (url, scheme, cred, domain, port, path, query, fragment) {
            do {
                var name = '\x01' + ((random() * 0x7fffffff)|0) + '\x02';
            } while (name in urls);
            url = scheme +
                  (cred || '') +
                  domain +
                  (port || '') +
                  (path || '') +
                  (query || '').replace(/&/g, '&amp;') +
                  (fragment || '');
            urls[name] = url;
            return name;
        });

        // escape most HTML
        field = _esc_most_html_sub(field, 0, field.length, []).join('');

        if (partials.args[1]) {
            const text = [];
            const lines = [];
            const split_lines = /([^\r\n]+)|([\r\n]+)/g;
            let m;
            while ( (m = split_lines.exec(field)) ) {
                const [is_ws, is_line] = m;
                if (is_line) {
                    lines.push(is_line);
                } else if (/(?:\r?\n|\r){2,}/.exec(is_ws)) {
                    text.push(lines.join('<br/>'));
                    lines.length = 0;
                }
            }
            text.push(lines.join('<br/>'));
            field = '<p>' + text.join('</p><p>') + '</p>';
        }

        // re-add links
        field = field.replace(/\x01.*?\x02/g, function (name) {
            const url = urls[name];
            return '<a href="' + url + '" rel="noopener">' + url + '</a>';
        });

        return field;
    }

    return _esc_most_html;
})();

function DISPLAY_JSON_LIST(view,partials,stack) {
    return '<pre>' + escapeHTML(stringify(view)) + '</pre>';
}

var DISPLAY_BUCHBEITRAG = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{.}}' +
    '</div>' +

    'In: {{titel_buch}}' +
    '{{#herausgeber}} – {{herausgeber}} (Hrsg.){{/}}' +
    '{{#auflage}} ({{auflage}} Aufl.){{/}}' +

    '{{#erscheinungs_ort|verlag|seitenzahl}}' +
        '<br />' +
        '{{#erscheinungs_ort}}{{erscheinungs_ort}}{{#verlag}}: {{/}}{{/}}' +
        '{{verlag}}' +
        '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +
    '{{/}}' +

    '{{#isbn}}<br />ISBN: {{isbn}}{{/}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_BUCHAUTORENSCHAFT = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{#auflage}} ({{auflage}} Aufl.){{/}}' +
        '{{.}}' +
    '</div>' +

    '{{#erscheinungs_ort|verlag|seitenzahl}}' +
        '{{#erscheinungs_ort}}{{erscheinungs_ort}}{{#verlag}}: {{/}}{{/}}' +
        '{{verlag}}' +
        '{{#seitenzahl}}{{#erscheinungs_ort|verlag}}. {{/}}{{seitenzahl}} S.{{/}}' +
    '{{/}}' +

    '{{#herausgeber}}<br />Hrsg.: {{herausgeber}}{{/}}' +

    '{{#isbn}}<br />ISBN: {{isbn}}{{/}}' +

    '{{#schriftenreihe}}<br />(' +
    '{{schriftenreihe}}{{#bandzaehlung}}; {{bandzaehlung}}{{/}}' +
    '){{/}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_BUCHHERAUSGEBERSCHAFT = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS|| (Hrsg.)}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{#auflage}} ({{auflage}} Aufl.){{/}}' +
        '{{.}}' +
    '</div>' +

    '{{#erscheinungs_ort|verlag|seitenzahl}}' +
        '{{#erscheinungs_ort}}{{erscheinungs_ort}}{{#verlag}}: {{/}}{{/}}' +
        '{{verlag}}' +
        '{{#seitenzahl}}{{#erscheinungs_ort|verlag}}. {{/}}{{seitenzahl}} S.{{/}}' +
    '{{/}}' +

    '{{#isbn}}<br />ISBN: {{isbn}}{{/}}' +

    '{{#schriftenreihe}}<br />(' +
        '{{schriftenreihe}}{{#bandzaehlung}}; {{bandzaehlung}}{{/}}' +
    '){{/}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_E_VEROEFFENTLICHUNG = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{.}}' +
    '</div>' +

    '{{#titel_website}}Webseite: {{titel_website}}{{/}}' +
    '{{#url}}{{#titel_website}}<br/>{{/}}{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_HOCHSCHULSCHRIFT = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}.' +
        '{{.}}' +
    '</div>' +

    '{{#erscheinungs_ort|verlag|seitenzahl}}' +
        '{{#erscheinungs_ort}}{{erscheinungs_ort}}{{#verlag}}: {{/}}{{/}}' +
        '{{verlag}}' +
        '{{#seitenzahl}}{{#erscheinungs_ort|verlag}}. {{/}}{{seitenzahl}} S.{{/}}' +
    '{{/}}' +

    '{{#herausgeber}}<br />Hrsg.: {{herausgeber}}{{/}}' +

    '{{#isbn}}<br />ISBN: {{isbn}}{{/}}' +

    '{{#schriftenreihe}}<br />(' +
        '{{schriftenreihe}}{{#bandzaehlung}}; {{bandzaehlung}}{{/}}' +
    '){{/}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_PATENTSCHRIFT = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{.}}' +
    '</div>' +

    '{{#erscheinungs_ort}}{{erscheinungs_ort}}: {{/}}' +
    '{{#seitenzahl}}{{seitenzahl}} S.{{/}}' +
    '{{#patentnummer}} {{patentnummer}}{{/}}' +

    '{{#url}}{{#erscheinungs_ort|seitenzahl|patentnummer}}<br/>{{/}}{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_POSTER = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{.}}' +
    '</div>' +

    '{{titel_kongress}}' +
    '{{#kongress_ort|kongress_datum}}' +
        '<br />' +
        '{{#kongress_ort}}' +
            '{{kongress_ort}}' +
            '{{#kongress_datum}} – {{/}}' +
        '{{/}}' +
        '{{> DISPLAY_KONGRESS_DURATION}}.' +
    '{{/}}' +

    '{{< switch subtype}}' +
        '{{< case buch}}' +
            '<br />' +
            'In: {{titel_buch}}' +
            '{{#herausgeber}} – {{herausgeber}} (Hrsg.){{/}}' +
            '{{#auflage}} ({{auflage}} Aufl.){{/}}' +

            '{{#erscheinungs_ort|verlag|seitenzahl|schriftenreihe}}' +
                '<br />' +
                '{{#erscheinungs_ort}}{{erscheinungs_ort}}{{#verlag}}: {{/}}{{/}}' +
                '{{verlag}}' +
                '{{#schriftenreihe}}{{.}} {{schriftenreihe}}{{/}}' +
                '{{#bandzaehlung}}{{. ";"}} <strong>{{bandzaehlung}}</strong>{{/}}' +
                '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +
            '{{/}}' +

            '{{#isbn}}<br />ISBN: {{isbn}}{{/}}' +

        '{{< case zeitschrift}}' +
            '<br />' +
            'In: ' +
            '{{> DISPLAY_JOURNAL_TITLE}}' +
            '{{#bandzaehlung|heftzaehlung}}; {{#bandzaehlung}}<strong>{{bandzaehlung}}</strong>{{/}}' +
                '{{#heftzaehlung}}({{heftzaehlung}}){{/}}' +
            '{{/}}' +
            '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +
    '{{< endswitch}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_REZENSION = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        'Rezension zu bzw. Rezensionstitel: {{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{.}}' +
    '</div>' +

    '{{< switch subtype}}' +
        '{{< case buch}}' +
            'In: {{titel_buch}}' +
            '{{#herausgeber}} – {{herausgeber}} (Hrsg.){{/}}' +
            '{{#auflage}} ({{auflage}} Aufl.){{/}}' +

            '{{#erscheinungs_ort|verlag|seitenzahl}}' +
                '<br />' +
                '{{#erscheinungs_ort}}{{erscheinungs_ort}}{{#verlag}}: {{/}}{{/}}' +
                '{{verlag}}' +
                '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +
            '{{/}}' +

            '{{#isbn}}<br />ISBN: {{isbn}}{{/}}' +

        '{{< case zeitschrift}}' +
            'In: ' +
            '{{> DISPLAY_JOURNAL_TITLE}}' +
            '{{#bandzaehlung|heftzaehlung}}; {{#bandzaehlung}}<strong>{{bandzaehlung}}</strong>{{/}}' +
                '{{#heftzaehlung}}({{heftzaehlung}}){{/}}' +
            '{{/}}' +
            '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +
    '{{< endswitch}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_RUNDFUNK_FERNSEH_BEITRAG = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{.}}' +
    '</div>' +

    '{{sender}}: {{sendung}}, {{> DISPLAY_WHOLE_DATE}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_VORTRAG = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{#titel_veranstaltung}}<br />{{titel_veranstaltung}}{{/}}' +
        '{{.}}' +
    '</div>' +

    '{{titel_kongress}}' +
    '{{#kongress_ort|kongress_datum}}' +
        '<br />' +
        '{{#kongress_ort}}' +
            '{{kongress_ort}}' +
            '{{#kongress_datum}} – {{/}}' +
        '{{/}}' +
        '{{> DISPLAY_KONGRESS_DURATION}}.' +
    '{{/}}' +

    '{{< switch subtype}}' +
        '{{< case kongressband}}' +
            '<br/>' +
            'In: {{titel_buch}}' +
            '{{#herausgeber}} – {{herausgeber}} (Hrsg.){{/}}' +
            '{{#auflage}} ({{auflage}} Aufl.){{/}}' +

            '{{#erscheinungs_ort|verlag|seitenzahl|schriftenreihe}}' +
                '<br />' +
                '{{#erscheinungs_ort}}{{erscheinungs_ort}}{{#verlag}}: {{/}}{{/}}' +
                '{{verlag}}' +
                '{{#schriftenreihe}}{{.}} {{schriftenreihe}}{{/}}' +
                '{{#bandzaehlung}}{{. ";"}} <strong>{{bandzaehlung}}</strong>{{/}}' +
                '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +
            '{{/}}' +

            '{{#isbn}}<br />ISBN: {{isbn}}{{/}}' +

        '{{< case zeitschrift}}' +
            '<br/>' +
            'In: ' +
            '{{> DISPLAY_JOURNAL_TITLE}}' +
            '{{#bandzaehlung|heftzaehlung}}; {{#bandzaehlung}}<strong>{{bandzaehlung}}</strong>{{/}}' +
                '{{#heftzaehlung}}({{heftzaehlung}}){{/}}' +
            '{{/}}' +
            '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +
    '{{< endswitch}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_WISS_BEITRAG = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{.}}' +
    '</div>' +

    '{{> DISPLAY_JOURNAL_TITLE}}' +
    '{{#bandzaehlung|heftzaehlung}}; {{#bandzaehlung}}<strong>{{bandzaehlung}}</strong>{{/}}' +
        '{{#heftzaehlung}}({{heftzaehlung}}){{/}}' +
    '{{/}}' +
    '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_ZEITSCHRIFTENGERAUSGEBERSCHAFT = (
    '<div class="PD_authors">' +
        '{{> DISPLAY_AUTHORS|| (Hrsg.)}}' +
    '</div>' +

    '<div class="PD_title">' +
        '{{> DISPLAY_JOURNAL_TITLE}}{{.}}' +
    '</div>' +

    '{{#bandzaehlung}}Band: {{bandzaehlung}}{{/}}' +
    '{{#heftzaehlung}}{{. ";"}} Heft: {{heftzaehlung}}{{/}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var  DISPLAY_PRESSESPIEGEL = (
    '<div class="PD_title" style="font-variant: small-caps;">' +
        '{{> ESC_MOST_HTML|titel}}' +
        '{{#untertitel}}{{. ":"}} {{> ESC_MOST_HTML|untertitel}}{{/}}' +
        '{{#titel_veranstaltung}}<br />{{titel_veranstaltung}}{{/}}' +
        ' ({{jahr}})' +
    '</div>' +

    '{{#authors.length}}' +
        '<div class="PD_authors" style="font-weight: normal; font-variant: normal;">' +
            'Autor: ' +
            '{{> DISPLAY_AUTHORS|||1}}' +
        '</div>' +
    '{{/}}' +

    '{{< switch subtype}}' +
        '{{< case zeitschrift}}' +
            'In: ' +
            '{{> DISPLAY_JOURNAL_TITLE}}' +
            '{{#bandzaehlung|heftzaehlung}}; {{#bandzaehlung}}<strong>{{bandzaehlung}}</strong>{{/}}' +
                '{{#heftzaehlung}}({{heftzaehlung}}){{/}}' +
            '{{/}}' +
            '{{#seitenzahl}}{{. ","}} S.\xA0{{> DISPLAY_SEITEN_VON_BIS}}{{/}}' +

        '{{< case rundfunk}}' +
            '{{sender}}: {{sendung}}, {{> DISPLAY_WHOLE_DATE}}' +

        '{{< case online}}' +
            'Webseite: {{titel_website}}' +
    '{{< endswitch}}' +

    '{{#url}}<br/>{{> DISPLAY_URL}}{{/}}'
);

var DISPLAY_ITEM = (
    '{{< switch typ}}' +
        '<strong class="error">Kein Handler für „{{typ}}“!</strong>' +
        '{{> DISPLAY_JSON_LIST}}' +
    '{{< case buchbeitrag}}' +
        '{{> DISPLAY_BUCHBEITRAG}}' +
    '{{< case buchautorenschaft}}' +
        '{{> DISPLAY_BUCHAUTORENSCHAFT}}' +
    '{{< case buchherausgeberschaft}}' +
        '{{> DISPLAY_BUCHHERAUSGEBERSCHAFT}}' +
    '{{< case e_veroeffentlichung}}' +
        '{{> DISPLAY_E_VEROEFFENTLICHUNG}}' +
    '{{< case hochschulschrift}}' +
        '{{> DISPLAY_HOCHSCHULSCHRIFT}}' +
    '{{< case patentschrift}}' +
        '{{> DISPLAY_PATENTSCHRIFT}}' +
    '{{< case poster}}' +
        '{{> DISPLAY_POSTER}}' +
    '{{< case rezension}}' +
        '{{> DISPLAY_REZENSION}}' +
    '{{< case rundfunk_fernseh_beitrag}}' +
        '{{> DISPLAY_RUNDFUNK_FERNSEH_BEITRAG}}' +
    '{{< case vortrag}}' +
        '{{> DISPLAY_VORTRAG}}' +
    '{{< case wissenschaftlicher_beitrag}}' +
        '{{> DISPLAY_WISS_BEITRAG}}' +
    '{{< case zeitschriftenherausgeberschaft}}' +
        '{{> DISPLAY_ZEITSCHRIFTENGERAUSGEBERSCHAFT}}' +
    '{{< case pressespiegel}}' +
        '{{> DISPLAY_PRESSESPIEGEL}}' +
    '{{< case }}' +
        '<strong class=error>Datenbankfehler: Leerer „type“-Eintrag!</strong>' +
        '{{> DISPLAY_JSON_LIST}}' +
    '{{< endswitch}}' +

    '{{> DISPLAY_DETAILS_LINK}}'
);

if (lang !== 'en') {
    var DISPLAY_PUBLICATION_TYPE_NAME = (
        '{{< switch type|typ}}' +
            '<strong class="error">Kein Handler für „{{type}}“!</strong>' +
        '{{< case buchautorenschaft}}' +
            'Buchautorenschaften' +
        '{{< case buchbeitrag}}' +
            'Buchbeiträge' +
        '{{< case buchherausgeberschaft}}' +
            'Buchherausgeberschaften' +
        '{{< case e_veroeffentlichung}}' +
            'Elektronische Veröffentlichungen' +
        '{{< case hochschulschrift}}' +
            'Hochschulschriften' +
        '{{< case patentschrift}}' +
            'Patentschriften' +
        '{{< case poster}}' +
            'Poster' +
        '{{< case rezension}}' +
            'Rezensionen' +
        '{{< case rundfunk_fernseh_beitrag}}' +
            'Rundfunk- und Fernsehbeiträge' +
        '{{< case vortrag}}' +
            'Vorträge' +
        '{{< case wissenschaftlicher_beitrag}}' +
            'Zeitschriftenartikel / wissenschaftliche Beiträge' +
        '{{< case zeitschriftenherausgeberschaft}}' +
            'Herausgeberschaften von Zeitschriften' +
        '{{< case pressespiegel}}' +
            'Pressespiegel' +
        '{{< case }}' +
            '<strong class="error">Datenbankfehler: Leerer „type“-Eintrag!</strong>' +
        '{{< endswitch}}'
    );
} else /* if (lang === 'en') */ {
    var DISPLAY_PUBLICATION_TYPE_NAME = (
        '{{< switch type|typ}}' +
            '<strong class="error">Kein Handler für „{{type}}“!</strong>' +
        '{{< case buchautorenschaft}}' +
            'Books' +
        '{{< case buchbeitrag}}' +
            'Book sections' +
        '{{< case buchherausgeberschaft}}' +
            'Edited books' +
        '{{< case e_veroeffentlichung}}' +
            'Electronic publications' +
        '{{< case hochschulschrift}}' +
            'Theses' +
        '{{< case patentschrift}}' +
            'Patents' +
        '{{< case poster}}' +
            'Posters' +
        '{{< case rezension}}' +
            'Recensions' +
        '{{< case rundfunk_fernseh_beitrag}}' +
            'Audio visual materials' +
        '{{< case vortrag}}' +
            'Oral presentations' +
        '{{< case wissenschaftlicher_beitrag}}' +
            'Journal articles' +
        '{{< case zeitschriftenherausgeberschaft}}' +
            'Edited journals' +
        '{{< case pressespiegel}}' +
            'Press reviews' +
        '{{< case }}' +
            '<strong class="error">Datenbankfehler: Leerer „type“-Eintrag!</strong>' +
        '{{< endswitch}}'
    );
}

if (lang !== 'en') {
    var DISPLAY_PUBLICATION_TYPE_NAME_SINGLULAR = (
        '{{< switch type|typ}}' +
            '<strong class="error">Kein Handler für „{{type}}“!</strong>' +
        '{{< case buchautorenschaft}}' +
            'Buchautorenschaft' +
        '{{< case buchbeitrag}}' +
            'Buchbeitrag' +
        '{{< case buchherausgeberschaft}}' +
            'Buchherausgeberschaft' +
        '{{< case e_veroeffentlichung}}' +
            'Elektronische Veröffentlichung' +
        '{{< case hochschulschrift}}' +
            'Hochschulschrift' +
        '{{< case patentschrift}}' +
            'Patentschrift' +
        '{{< case poster}}' +
            'Poster' +
        '{{< case rezension}}' +
            'Rezension' +
        '{{< case rundfunk_fernseh_beitrag}}' +
            'Rundfunk- und Fernsehbeitrag' +
        '{{< case vortrag}}' +
            'Vortrag' +
        '{{< case wissenschaftlicher_beitrag}}' +
            'Zeitschriftenartikel / wissenschaftlicher Beitrag' +
        '{{< case zeitschriftenherausgeberschaft}}' +
            'Herausgeberschaft einer Zeitschrift' +
        '{{< case pressespiegel}}' +
            'Pressespiegel' +
        '{{< case }}' +
            '<strong class="error">Datenbankfehler: Leerer „type“-Eintrag!</strong>' +
        '{{< endswitch}}'
    );
} else /* if (lang === 'en') */ {
    var DISPLAY_PUBLICATION_TYPE_NAME_SINGLULAR = (
        '{{< switch type|typ}}' +
            '<strong class="error">Kein Handler für „{{type}}“!</strong>' +
        '{{< case buchautorenschaft}}' +
            'Book' +
        '{{< case buchbeitrag}}' +
            'Book section' +
        '{{< case buchherausgeberschaft}}' +
            'Edited book' +
        '{{< case e_veroeffentlichung}}' +
            'Electronic publication' +
        '{{< case hochschulschrift}}' +
            'Thesis' +
        '{{< case patentschrift}}' +
            'Patent' +
        '{{< case poster}}' +
            'Poster' +
        '{{< case rezension}}' +
            'Recension' +
        '{{< case rundfunk_fernseh_beitrag}}' +
            'Audio visual material' +
        '{{< case vortrag}}' +
            'Oral presentation' +
        '{{< case wissenschaftlicher_beitrag}}' +
            'Journal article' +
        '{{< case zeitschriftenherausgeberschaft}}' +
            'Edited journal' +
        '{{< case pressespiegel}}' +
            'Press review' +
        '{{< case }}' +
            '<strong class="error">Datenbankfehler: Leerer „type“-Eintrag!</strong>' +
        '{{< endswitch}}'
    );
}

var DISPLAY_DETAILS_LINK = (
    '{{- if id != "0"}}' +
        '{{- if id != ""}}' +
            '<div class="PD_link_details noprint" style="margin-top:0.33em">' +
                '<a href="{{> PATH_ROOT}}/pub/{{id}}{{#url_title}}-{{url_title}}{{/}}/' +
                    (lang !== 'en' ? '' : '?lang=en') +
                '">Details</a>' +
            '</div>' +
        '{{- endif}}' +
    '{{- endif}}'
);

var DISPLAY_ACTION_MENU = (
    '<div class="PD_actions noprint">' +
        '<a href="javascript:void(0)" title="Anklicken zum Öffnen des Menüs." style="text-align: right;">' +
            (lang !== 'en' ? 'Auswahl ' : 'Selection ') +
            '<img src="{{> PATH_STATIC}}/images/arrow_down_small.png" alt="" />' +
        '</a>' +

        '<form action="javascript:;" method="POST" unselectable="on">' +
            '<img src="{{> PATH_STATIC}}/images/close.png" alt="schließen" title="schließen" class="PD_actions_close" />' +

            '<div class="PD_actions_scope">' +
                '<label style="margin-top: 12px;">' +
                    '<input type="radio" name="export-scope" value="selected" checked style="margin-left: 0;" />' +
                    (lang !== 'en' ? 'Selektierte Publikationen' : 'Selected publications')+
                '</label>' +
                '<label>' +
                    '<input type="radio" name="export-scope" value="page" style="margin-left: 0;" />' +
                    (lang !== 'en' ? 'Publikationen auf dieser Seite' : 'All publications on this page') +
                '</label>' +
            '</div>' +

            '<img src="{{> PATH_STATIC}}/images/arrow_down_big.png" alt="" style="margin: auto; display: block" />' +

            '<h4>' + (lang !== 'en' ? 'Datenexport' : 'Export') + ':</h4>' +
            '<div class="PD_actions_action">' +
                '<label>' +
                    '<input type="radio" name="export-action" value="export-ris" checked />' +
                    (lang !== 'en' ? 'EndNote („.ris“-Datei)' : 'EndNote (“.ris” file)') +
                '</label>' +
                '<label>' +
                    '<input type="radio" name="export-action" value="export-csv" />' +
                    (lang !== 'en' ? 'Excel-kompatible CSV-Datei' : 'CSV file (openable by e.g. Excel)') +
                '</label>' +
                '<label>' +
                    '<input type="radio" name="export-action" value="details" />' +
                    'Detailansicht' +
                '</label>' +
            '</div>' +

            '{{#~.pubdb.csrf_token}}' + // csrf_token implies login_details
                '<h4>Hinzufügen zu Publikationsverzeichnis:</h4>' +
                '{{#~.pubdb.login_details.pages}}' +
                    '<label>' +
                        '<input type="radio" name="export-action" value="userpage-{{0}}" />' +
                        '{{1}}' +
                    '</label>' +
                '{{/}}' +
                '{{^~.pubdb.login_details.pages}}' +
                    '<label>' +
                        '<a href="{{> PATH_ROOT}}/userpage/" target="_blank">Noch keine angelegt.</a>' +
                    '</label>' +
                '{{/}}' +
            '{{/}}' +

            '<label style="text-align: center;" class="PD_actions_go" unselectable="on">' +
                'Bitte aktivieren Sie Flash!' +
            '</label>' +
        '</form>' +
    '</div>'
);

var DISPLAY_UNSORTED_LIST = (
    '<div class="PD_display_list PD_order_by_years">' +
        '{{> DISPLAY_ACTION_MENU}}' +

        '<ul class="PD_items">' +
            '{{#years}}' + // sic
                '<li class="PD_item" id="PubDB_{{id}}" data-pubid="{{id}}">' +
                    '<input type="checkbox" />' +
                    '<div class="PD_content">' +
                        '{{> DISPLAY_ITEM}}' +
                    '</div>' +
                '</li>' +
            '{{/}}' +
        '</ul>' +
    '</div>'
);

var DISPLAY_LIST = (
    '<div class="PD_display_list PD_order_by_years">' +
        '{{> DISPLAY_ACTION_MENU}}' +

        '{{- if display_navigation || ""}}' +
            '<div class="PD_section_links noprint">' +
                '{{#years}}' +
                    '<span>' +
                        '<a href="#PD_year_{{year}}">{{year}}</a>' +
                    '</span>' +
                '{{/}}' +
            '</div>' +
        '{{- endif}}' +

        '<ul class="PD_years">' +
        '{{#years}}' +
            '<li class="PD_year" id="PD_year_{{year}}">' +
                '<div class="PD_headline PD_headline_year">' +
                    (lang !== 'en' ? 'Publikationsliste ' : 'Publications in ') +
                    '{{- if year != ""}}{{year}}' +
                    '{{- else}}(' + (lang !== 'en' ? 'unbestimmtes Jahr' : 'undefined year') + ')' +
                    '{{- endif }}' +
                '</div>' +

                '{{- if display_navigation || ""}}' +
                    '<div class="PD_section_links noprint">' +
                        '{{#items}}' +
                            '<span>' +
                                '<a href="#PD_item_{{year}}_{{type}}">{{> DISPLAY_PUBLICATION_TYPE_NAME}}</a>' +
                            '</span>' +
                        '{{/}}' +
                    '</div>' +
                '{{- endif}}' +

                '<ul class="PD_types">' +
                '{{#items}}' +
                    '<li class="PD_type PD_type_{{type}}" id="PD_item_{{year}}_{{type}}">' +
                        '<div class="PD_headline PD_headline_type">' +
                            '{{> DISPLAY_PUBLICATION_TYPE_NAME}}:' +
                        '</div>' +

                        '<ul class="PD_items">' +
                        '{{#items}}' +
                            '<li class="PD_item" id="PubDB_{{id}}" data-pubid="{{id}}">' +
                                '<input type="checkbox" />' +
                                '<div class="PD_content">' +
                                    '{{> DISPLAY_ITEM}}' +
                                '</div>' +
                            '</li>' +
                        '{{/}}' +
                        '</ul>' +
                    '</li>' +
                '{{/}}' +
                '</ul>' +
            '</li>' +
        '{{/}}' +
        '</ul>' +
    '</div>'
);

var DISPLAY_PRESSESPIEGEL_LIST = (
    '<div class="PD_display_list PD_order_by_years">' +
        '{{> DISPLAY_ACTION_MENU}}' +

        '{{- if display_navigation || ""}}' +
            '<div class="PD_section_links noprint">' +
                '{{#years}}' +
                    '<span>' +
                        '<a href="#PD_year_{{year}}">{{year}}</a>' +
                    '</span>' +
                '{{/}}' +
            '</div>' +
        '{{- endif}}' +

        '<ul class="PD_years">' +
        '{{#years}}' +
            '<li class="PD_year" id="PD_year_{{year}}">' +
                '<div class="PD_headline PD_headline_year">' +
                    (lang !== 'en' ? 'Pressespiegel ' : 'Press review in ') +
                    '{{- if year != ""}}{{year}}' +
                    '{{- else}}(' + (lang !== 'en' ? 'unbestimmtes Jahr' : 'undefined year') + ')' +
                    '{{- endif }}' +
                '</div>' +

                '<ul class="PD_types">' +
                '{{#items}}' +
                    '<li class="PD_type PD_type_{{type}}" id="PD_item_{{year}}_{{type}}">' +
                        '<ul class="PD_items">' +
                        '{{#items}}' +
                            '<li class="PD_item" id="PubDB_{{id}}" data-pubid="{{id}}">' +
                                '<input type="checkbox" />' +
                                '<div class="PD_content">' +
                                    '{{> DISPLAY_PRESSESPIEGEL}}' +
                                    '{{> DISPLAY_DETAILS_LINK}}' +
                                '</div>' +
                            '</li>' +
                        '{{/}}' +
                        '</ul>' +
                    '</li>' +
                '{{/}}' +
                '</ul>' +
            '</li>' +
        '{{/}}' +
        '</ul>' +
    '</div>'
);

function shorten_firstname_simple (name) {
    return name.replace(/([\S.-])[^\0- -]*/g, '$1.');
}

function DISPLAY_AUTHORS (view,partials,stack) {
    function render_author(author) {
        if(result) {
            result += '; ';
        }
        var firstname = trim(author.firstname);
        var lastname = escapeHTML(trim(author.lastname));
        result += '<span title="' + lastname + (firstname ? ', ' + escapeHTML(firstname) : '') + '">' + lastname;
        if(firstname) {
            var firstnames = firstname.split(/\s+-\s*|\s+/g);
            for (var i = 0; i < firstnames.length; ++i) {
                if (firstnames[i].indexOf('.') >= 0) {
                    continue;
                }
                firstnames[i] = map(firstnames[i].split('-'), shorten_firstname_simple).join('-');
            }
            result += ', ' + firstnames.join(' ');
        }
        result += '</span>';
    }

    var authors = lookup('authors', stack, '');
    if(!authors || !authors.length) {
        return '<strong class="error">Keine Autoren angegeben!</strong>';
    }
    var result = '';
    for (var i = 0; i < authors.length; ++i) {
        render_author(authors[i]);
    }
    if ('args' in partials) {
        result  = (partials.args[0]||'') + result + (partials.args[1]||'');
        var no_year = !!partials.args[2];
        partials = extend({}, partials);
        delete partials.args;
    }
    var year = DISPLAY_YEAR(view,partials,stack);
    if (!no_year) {
        result += ' (' + year + '):';
    }
    return result;
}

function DISPLAY_JOURNAL_ISSN (view,partials,stack) {
    const { issns } = view;
    const { args } = partials;
    const type = args[0];
    const title = escapeHTML(args[1]);
    for (let i = 0, { length } = issns; i < length; ++i) {
        let issn = issns[i];
        if (issn.type !== type) {
            continue;
        }

        issn = issn.issn;
        if (!issn || (issn === view.issn)) {
            return '';
        }

        issn = escapeHTML(issn);
        return (
            '<p>' +
                '<strong>' + title + '</strong>: ' +
                '<a class="pubdb-issn-link" href="' + path_root + '/issn/' + issn + '/">' + issn + '</a>' +
            '</p>'
        );
    }
    return '';
}

function DISPLAY_IGNORED_MESSAGES (view,partials,stack) {
    var ignored_messages = lookup('new', stack, '');
    if (!ignored_messages) {
        return '';
    }
    return map(ignored_messages.split(','), function (v) {
        return {
            bandzaehlung_okay: 'Bandzählung und die Heftzählung vermischt?',
            titel_no_period_okay: 'Der Titel sollte nicht auf einen Punkt enden.',
            case_okay: 'Die Schreibweise des Titels ist ungewöhnlich.',
            firstnames_okay: 'Nicht alle Autoren haben einen Vornamen.',
            chose_we_okay: 'Bei keinem Autor wurde eine WE eingetragen.',
            doi_valid_format: 'DOI hat ungültiges Format.',
            doi_not_a_url_okay: 'DOI ist vermutlich eine URL.',
            display_for_we_okay: 'Keine WE für Publikation angegeben.',
            kongress_zeitraum_okay: 'Letzter Kongresstag liegt vor dem ersten.',
            kongressband_one_author: 'Beiträge zu Kongressbänden haben häufig mehrere Autoren.',
        }[v] || v;
    }).join('</li><li>• ');
}

function DISPLAY_LOG_IDLIST (view,partials,stack,lookup) {
    const [ log_entry_source, field ] = partials.args;
    const ids = trim(view[field] || '');
    return ids && (
        ids.
        split(',').
        map(escapeHTML).
        map(id => `<a href="${path_root}/${log_entry_source}/${id}/log/">${id}</a>`).
        join(', ')
    );
}

var DISPLAY_JOURNAL = (
    '{{#journal}}' +
        '{{#journal}}' +
            (!hasRole('editor') ? '' :
                '<p>' +
                    '<a href="{{> PATH_ROOT}}/journal/{{id}}/edit/">bearbeiten</a> – ' +
                    '<a href="{{> PATH_ROOT}}/journal/{{id}}/delete/">löschen</a> – ' +
                    '<a href="{{> PATH_ROOT}}/journal/{{id}}/move/">alle Einträge verschieben</a>' +
                    (has_role('log-viewer') ? ' – <a href="{{> PATH_ROOT}}/journal/{{id}}/log/">Logbuch</a>' : '') +
                '</p>' +
                '<hr />'
            ) +
            '<p><strong>Titel:</strong> {{title}}{{#subtitle}} : {{subtitle}}{{/}}</p>' +
            '{{#verlag}}<p><strong>Verlag:</strong> {{verlag}}</p>{{/}}' +
            '{{#ort}}<p><strong>Erscheinungsort:</strong> {{ort}}</p>{{/}}' +
            '{{#abbrev}}<p><strong>Abkürzung:</strong> {{abbrev}}</p>{{/}}' +
            '{{#zdbid}}<p><strong>ZDB-ID:</strong> <a href="https://ld.zdb-services.de/resource/{{zdbid}}" rel="noopener">{{zdbid}}</a></p>{{/}}' +
            '{{#issn}}<p><strong>ISSN:</strong> <a class="pubdb-issn-link" href="{{> PATH_ROOT}}/issn/{{issn}}/">{{issn}}</a></p>{{/}}' +
            '{{> DISPLAY_JOURNAL_ISSN|print|p-ISSN}}' +
            '{{> DISPLAY_JOURNAL_ISSN|electronic|e-ISSN}}' +
            '{{> DISPLAY_JOURNAL_ISSN|link|ISSN-L}}' +
        '{{/}}' +
    '{{/}}'
);

var DISPLAY_JOURNAL_TITLE = (
    '{{#journal}}' +
        '{{title}}' +
        (!login_details ? '' : '<sup>[<a href="{{> PATH_ROOT}}/journal/{{id}}/" title="Dieser Link wird Ihnen angezeigt, weil Sie angemeldet sind.">Details</a>]</sup>') +
    '{{/}}'
);

var DISPLAY_JOURNALS = (
    '{{#journals}}' +
        '<div data-key="{{key}}">' +
            '{{#journals}}' +
                '<p>' +
                    '<strong>{{title}}</strong>{{#subtitle}} : {{subtitle}}{{/}}{{#abbrev}} ({{abbrev}}){{/}}' +
                    '{{#issn}}<br />' +
                        'ISSN: <a class="pubdb-issn-link" href="{{> PATH_ROOT}}/issn/{{issn}}/">{{issn}}</a>' +
                    '{{/}}' +
                    '<br/><small><a href="{{> PATH_ROOT}}/journal/{{id}}/">Details</a></small>' +
                '</p>' +
            '{{/}}' +
        '</div>' +
    '{{/}}'
);

var DISPLAY_FPKEYWORDS = (
    '<div class="PD_display_list">' +
        '<div class="PD_section_links">' +
            '{{#fpkeywords}}' +
                '<div style="display:inline-block"{{#description}} class="pubdb-tooltipped"{{/}}>' +
                    '<span>' +
                        ' <a href="{{> PATH_ROOT}}/fpkeyword/{{id}}/" style="padding:0.2em; font-size:1.1em;">{{en}}</a> ' +
                    '</span>' +
                    '{{#description}}' +
                        '<div style="display:none; max-width:400px;">' +
                            '{{> ESC_MOST_HTML|description|1}}' +
                        '</div>' +
                    '{{/}}' +
                '</div>' +
            '{{/}}' +
        '</div>' +
    '</div>'
);

var DISPLAY_EDITOR_LOG_ROW_OLD = (
    '<td style="background-color:#FFDFDF; white-space:pre-wrap;">' +
        '{{- if name === "authors"}}{{> DISPLAY_LOG_IDLIST|author|old}}' +
        '{{- elif name === "journal_id"}}{{> DISPLAY_LOG_IDLIST|journal|old}}' +
        '{{- elif name === "forschungsprojekt_id"}}{{> DISPLAY_LOG_IDLIST|forschungsprojekt|old}}' +
        '{{- elif name === "fpkeyword_id"}}{{> DISPLAY_LOG_IDLIST|fpkeyword|old}}' +
        '{{- else}}{{old}}{{- endif}}' +
    '</td>'
);

var DISPLAY_EDITOR_LOG_ROW_NEW = (
    '<td style="background-color:#BEFEEB; white-space:pre-wrap;">' +
        '{{- if name === "authors"}}{{> DISPLAY_LOG_IDLIST|author|new}}' +
        '{{- elif name === "journal_id"}}{{> DISPLAY_LOG_IDLIST|journal|new}}' +
        '{{- elif name === "forschungsprojekt_id"}}{{> DISPLAY_LOG_IDLIST|forschungsprojekt|new}}' +
        '{{- elif name === "fpkeyword_id"}}{{> DISPLAY_LOG_IDLIST|fpkeyword|new}}' +
        '{{- else}}{{new}}{{- endif}}' +
    '</td>'
);

var DISPLAY_EDITOR_LOG_ENTRY = (
    '<strong>Bearbeiter:</strong> ' +
    '{{#user}}' +
        '<a href="{{> PATH_ROOT}}/user/{{user_id}}/">{{user_email}}</a>' +
    '{{/}}' +
    '{{^user}}' +
        '<em>Gelöschter Benutzer </em>' +
        '<a href="{{> PATH_ROOT}}/user/{{user_email}}/log/">{{user_email}}</a>' +
        '<em> (#{{user_id}})</em>' +
    '{{/}}' +
    '{{#ip}}' +
        ' (<a href="{{> BASE_HREF}}/intern/whois.sh?{{ip}}" rel="noopener">{{ip}}</a>)' +
    '{{/}}' +
    '<br />' +

    '<strong>Zeitpunkt:</strong> {{#timestamp}}{{> DISPLAY_BERLIN_TIMESTAMP}}{{/}}<br />' +
    '<strong>Bearbeitungsart:</strong> {{edit_type}}<br />' +
    '<strong>Bearbeitungsziel:</strong> <a href="{{> PATH_ROOT}}/{{datum_type}}/{{datum_id}}/">{{datum_type}} #{{datum_id}}</a><br />' +
    (has_role('log-viewer') ? '<strong>Logbucheintrag:</strong> <a href="{{> PATH_ROOT}}/log/{{id}}/">#{{id}}</a><br/>' : '') +
    '{{#review_ts}}' +
        '<strong>Review:</strong> ' +
        '<a href="{{> PATH_ROOT}}/user/{{reviewer.id}}/">{{reviewer.account_name}}</a>' +
        '; um {{> DISPLAY_BERLIN_TIMESTAMP|review_ts}}<br/>' +
    '{{/}}' +

    '<div style="overflow-x:auto"><table style="background-color:#fff; margin:0; width:100%">' +
    '{{< switch edit_type}}' +
        // default, case edit:
            '<tr>' +
                '<th style="width:1">Feld</th>' +
                '<th style="width:50%">Alt</th>' +
                '<th style="width:50%">Neu</th>' +
            '</tr>' +
            '{{#fields}}<tr>' +
                '{{- if name !== "ignored_messages"}}' +
                    '<th style="white-space:nowrap" title="Unterschied anzeigen" class="-show-diff">' +
                        '{{name}}' +
                        '<a href="javascript:;" style="padding:0 0.25ex" title="Unterschiedliche Wörter." data-diff="diffWordsWithSpace">[W]</a>' +
                        '<a href="javascript:;" style="padding:0 0.25ex" title="Unterschiedliche Buchstaben." data-diff="diffChars">[B]</a>' +
                        '<a href="javascript:;" style="padding:0 0.25ex" title="Unterschiedliche Sätze." data-diff="diffSentences">[S]</a>' +
                        '<a href="javascript:;" style="padding:0 0.25ex" title="Unterschiedliche Zeilen." data-diff="diffTrimmedLines">[Z]</a>' +
                    '</th>' +
                    '{{> DISPLAY_EDITOR_LOG_ROW_OLD}}' +
                    '{{> DISPLAY_EDITOR_LOG_ROW_NEW}}' +
                '{{- else}}' +
                    '<th>{{name}}</th>' +
                    '<td colspan="2" style="background-color:#FFDFDF;">' +
                        '<ul style="margin: 0;"><li>• {{> DISPLAY_IGNORED_MESSAGES}}</ul></li>' +
                    '</td>' +
                '{{- endif}}' +
            '</tr>{{/}}' +

        '{{< case create}}' +
            '<tr>' +
                '<th style="width:1">Feld</th>' +
                '<th style="width:100%">Neu</th>' +
            '</tr>' +
            '{{#fields}}<tr>' +
                '<th>{{name}}</th>' +
                '{{- if name !== "ignored_messages"}}' +
                    '{{> DISPLAY_EDITOR_LOG_ROW_NEW}}' +
                '{{- else}}' +
                    '<td style="background-color:#FFDFDF;">' +
                        '<ul style="margin: 0;"><li>• {{> DISPLAY_IGNORED_MESSAGES}}</ul></li>' +
                    '</td>' +
                '{{- endif}}' +
            '</tr>{{/}}' +

        '{{< case delete}}' +
            '<tr>' +
                '<th style="width:1">Feld</th>' +
                '<th style="width:100%">Alt</th>' +
            '</tr>' +
            '{{#fields}}<tr>' +
                '<th>{{name}}</th>' +
                '{{- if name !== "ignored_messages"}}' +
                    '{{> DISPLAY_EDITOR_LOG_ROW_OLD}}' +
                '{{- else}}' +
                    '<td colspan="2" style="background-color:#FFDFDF;">' +
                        '<ul style="margin: 0;"><li>• {{> DISPLAY_IGNORED_MESSAGES}}</ul></li>' +
                    '</td>' +
                '{{- endif}}' +
            '</tr>{{/}}' +
    '{{< endswitch}}' +
    '</table></div>'
);

var DISPLAY_FORSCHUNGSPROJEKT = (
    '{{#veroeffentlichen}}' +
        '<h3 class="PD_title" style="margin:1.4em 0 0.2em 0">' +
            '<a href="{{> PATH_ROOT}}/forschungsprojekt/{{id}}/">' +
                (lang !== 'en' ? (
                    '{{#titel_ger}}{{> ESC_MOST_HTML|titel_ger}}{{/}}' +
                    '{{^titel_ger}}{{> ESC_MOST_HTML|titel_eng}}{{/}}'
                ) : (
                    '{{#titel_eng}}{{> ESC_MOST_HTML|titel_eng}}{{/}}' +
                    '{{^titel_ger}}{{> ESC_MOST_HTML|titel_ger}}{{/}'
                )) +
            '</a>' +
        '</h3>' +
        (lang !== 'en' ? (
            '{{#abstract_ger}}' +
                '<p><strong>Beschreibung: </strong>{{> ESC_MOST_HTML|abstract_ger}}</p>' +
            '{{/}}' +
            '{{^abstract_ger}}' +
                '{{#abstract_eng}}' +
                    '<p><strong>Beschreibung: </strong>{{> ESC_MOST_HTML|abstract_eng}}</p>' +
                '{{/}}' +
            '{{/}}' +
            '{{#ansprech_name}}' +
                '<p><strong>Projektleitung: </strong>{{ansprech_name}}</p>' +
            '{{/}}' +
            '{{#beginn}}' +
                '<p><strong>Projektlaufzeit: </strong>{{> DISPLAY_WHOLE_DATE|.}}{{#ende}} bis {{> DISPLAY_WHOLE_DATE|.}}{{/}}</p>' +
            '{{/}}'
        ) : (
            '{{#abstract_eng}}' +
                '<p><strong>Outline: </strong>{{> ESC_MOST_HTML|abstract_eng}}</p>' +
            '{{/}}' +
            '{{^abstract_eng}}' +
                '{{#abstract_ger}}' +
                    '<p><strong>Outline: </strong>{{> ESC_MOST_HTML|abstract_ger}}</p>' +
                '{{/}}' +
            '{{/}}' +
            '{{#ansprech_name}}' +
                '<p><strong>Project lead: </strong>{{ansprech_name}}</p>' +
            '{/}}' +
            '{{#beginn}}' +
                '<p><strong>Project duration: </strong>{{> DISPLAY_WHOLE_DATE|.}}{{#ende}} to {{> DISPLAY_WHOLE_DATE|.}}{{/}}</p>' +
            '{{/}}'
        )) +
    '{{/}}'
);

var DISPLAY_FORSCHUNGSPROJEKTS = (
    '{{#projects}}' +
        '{{> DISPLAY_FORSCHUNGSPROJEKT}}' +
    '{{/}}'
);

var NO_RESULTS_YET = '<strong class="error">Ihre Suchanfrage lieferte keine Treffer.</strong>';

var EXPORT_CSV = (
    '\uFEFF' +
    '"Art";' +
    '"Titel";' +
    '"Untertitel";' +
    '"Autoren";' +
    '"Erscheinungsdatum";' +
    '"Erscheinungsort";' +
    '"ISBN";' +
    '"Verlag";' +
    '"Bandzählung";' +
    '"Heftzählung";' +
    '"Auflage";' +
    '"Gesamtseitenzahl oder erste Seite";' +
    '"letzte Seite";' +
    '"Schriftenreihe";' +
    '"Pubmed ID";' +
    '"DOI";' +
    '"Herausgeber";' +
    '"Patentnummer";' +
    '"Zusammenfassung";' +
    '"Buchtitel";' +
    '"Titel der Zeitschrift";' +
    '"ISSN";' +
    '"Erscheinungsort der Zeitschrift";' +
    '"Verlag der Zeitschrift";' +
    '"Titel der Webseite";' +
    '"Titel des Kongresses";' +
    '"Titel der Veranstaltung";' +
    '"Veranstaltungsort des Kongresses";' +
    '"Veranstaltungsdatum des Kongresses";' +
    '"URL";' +
    '"URN";' +
    '"Sender";' +
    '"Sendung";' +
    '"Sprache";' +
    '{{#data}}' +
        '\n' +
        '"{{typ}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|titel}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|untertitel}}";' +
        '"{{#authors}}{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|lastname}},{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|firstname}};{{/}}";' +
        '"{{> DISPLAY_WHOLE_DATE|datum}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|erscheinungs_ort}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|isbn}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|verlag}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|bandzaehlung}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|heftzaehlung}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|auflage}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|seitenzahl}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|seitenzahl_ende}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|schriftenreihe}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|pubmed}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|doi}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|herausgeber}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|patentnummer}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|abstract}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|titel_buch}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|journal.title}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|journal.issn}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|journal.erscheinungs_ort}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|journal.verlag}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|titel_website}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|titel_kongress}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|titel_veranstaltung}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|kongress_ort}}";' +
        '"{{#kongress_datum}}{{> DISPLAY_WHOLE_DATE|kongress_datum}}{{/}}' +
        '{{#kongress_ende}}-{{> DISPLAY_WHOLE_DATE|kongress_ende}}{{/}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|url}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|urn}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|sender}}";' +
        '"{{> ESCAPE_DOUBLE_QUOTES_FOR_CSV|sendung}}";' +
        '"{{sprache.name_ger}}"' +
    '{{/}}'
);

function EXPORT_RIS_LINE (view, partials, stack, lookup, escapeHTML, renderSection, render) {
    var content = find_in_stack(stack, [partials.args[1]]);
    if (content) {
        return partials.args[0] + '  - ' + escapeHTML(content) + '\n';
    } else {
        return '';
    }
}

var EXPORT_RIS = (
    'Provider: Veterinärmedizinische Bibliothek der Freien Universität Berlin\n' +
    'Database: Publikationsdatenbank\n' +
    'Content: text/plain; charset="UTF-8"\n' +
    '\n' +
    '{{#data}}' +
        '{{< switch typ}}' +
        '{{< case wissenschaftlicher_beitrag}}' +
        'TY  - JOUR\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|OP|journal.title}}' +
        '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
        '{{> EXPORT_RIS_LINE|PB|verlag}}' +
        '{{> EXPORT_RIS_LINE|SN|journal.issn}}' +
        '{{> EXPORT_RIS_LINE|DO|doi}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|M1|heftzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case buchautorenschaft}}' +
        'TY  - BOOK\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|ET|auflage}}' +
        '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
        '{{> EXPORT_RIS_LINE|PB|verlag}}' +
        '{{> EXPORT_RIS_LINE|SN|isbn}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case buchbeitrag}}' +
        'TY  - CHAP\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|OP|titel_buch}}' +
        '{{> EXPORT_RIS_LINE|ET|auflage}}' +
        '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
        '{{> EXPORT_RIS_LINE|AU|herausgeber}}' +
        '{{> EXPORT_RIS_LINE|PB|verlag}}' +
        '{{> EXPORT_RIS_LINE|SN|isbn}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|DO|doi}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case buchherausgeberschaft}}' +
        'TY  - BOOK\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T3  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|ET|auflage}}' +
        '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
        '{{> EXPORT_RIS_LINE|PB|verlag}}' +
        '{{> EXPORT_RIS_LINE|SN|isbn}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case vortrag}}' +
        'TY  - CPAPER\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T3  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|T2|titel_kongress}}'+
        '{{> EXPORT_RIS_LINE|CY|kongress_ort}}'+
        '{{- if subtype == "zeitschrift"}}'+
             '{{> EXPORT_RIS_LINE|OP|journal.title}}'+
             '{{> EXPORT_RIS_LINE|PB|journal.verlag}}'+
             '{{> EXPORT_RIS_LINE|SN|journal.issn}}' +
             '{{> EXPORT_RIS_LINE|M1|heftzaehlung}}' +
        '{{- elif subtype == "kongressband"}}'+
             '{{> EXPORT_RIS_LINE|OP|titel_buch}}'+
             '{{> EXPORT_RIS_LINE|PB|verlag}}' +
             '{{> EXPORT_RIS_LINE|SN|isbn}}' +
        '{{- endif}}' +
        '{{> EXPORT_RIS_LINE|ET|auflage}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|DO|doi}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case poster}}' +
        'TY  - CONF\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T3  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|T2|titel_kongress}}'+
        '{{> EXPORT_RIS_LINE|CY|kongress_ort}}'+
        '{{- if subtype == "zeitschrift"}}'+
             '{{> EXPORT_RIS_LINE|OP|journal.title}}'+
             '{{> EXPORT_RIS_LINE|PB|journal.verlag}}'+
             '{{> EXPORT_RIS_LINE|SN|journal.issn}}' +
             '{{> EXPORT_RIS_LINE|M1|heftzaehlung}}' +
        '{{- elif subtype == "buch"}}'+
             '{{> EXPORT_RIS_LINE|OP|titel_buch}}'+
             '{{> EXPORT_RIS_LINE|PB|verlag}}' +
             '{{> EXPORT_RIS_LINE|SN|isbn}}' +
        '{{- endif}}' +
        '{{> EXPORT_RIS_LINE|ET|auflage}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|DO|doi}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case hochschulschrift}}' +
        'TY  - THESIS\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
        '{{> EXPORT_RIS_LINE|PB|verlag}}' +
        '{{> EXPORT_RIS_LINE|SN|isbn}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case rundfunk_fernseh_beitrag}}' +
        'TY  - ADVS\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|C1|sender}}' +
        '{{> EXPORT_RIS_LINE|C2|sendung}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.naendme_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case rezension}}' +
        'TY  - JOUR\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{- if subtype == "zeitschrift"}}'+
             '{{> EXPORT_RIS_LINE|OP|journal.title}}'+
             '{{> EXPORT_RIS_LINE|PB|journal.verlag}}'+
             '{{> EXPORT_RIS_LINE|CY|journal.erscheinungs_ort}}'+
             '{{> EXPORT_RIS_LINE|SN|journal.issn}}' +
             '{{> EXPORT_RIS_LINE|M1|heftzaehlung}}' +
        '{{- elif subtype == "buch"}}'+
             '{{> EXPORT_RIS_LINE|OP|titel_buch}}'+
             '{{> EXPORT_RIS_LINE|ET|auflage}}' +
             '{{> EXPORT_RIS_LINE|PB|verlag}}' +
             '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
             '{{> EXPORT_RIS_LINE|SN|isbn}}' +
        '{{- endif}}' +
        '{{> EXPORT_RIS_LINE|VL|bandzaehlung}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|DO|doi}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case e_veroeffentlichung}}' +
        'TY  - GEN\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|OP|titel_website}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case patentschrift}}' +
        'TY  - PAT\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
        '{{> EXPORT_RIS_LINE|C1|patentnummer}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< case zeitschriftenherausgeberschaft}}' +
        'TY  - GEN\n' +
        'N1  - {{> PATH_ROOT}}/pub/{{id}}/\n' +
        'TI  - {{> ESC_MOST_HTML|titel}}\n' +
        '{{#untertitel}}T2  - {{> ESC_MOST_HTML|untertitel}}\n{{/}}' +
        '{{#authors}}AU  - {{lastname}}, {{firstname}}\n{{/}}' +
        'PY  - {{jahr}}\n' +
        '{{> EXPORT_RIS_LINE|ET|auflage}}' +
        '{{> EXPORT_RIS_LINE|CY|erscheinungs_ort}}' +
        '{{> EXPORT_RIS_LINE|PB|verlag}}' +
        '{{> EXPORT_RIS_LINE|SN|journal.issn}}' +
        '{{> EXPORT_RIS_LINE|SP|seitenzahl}}' +
        '{{> EXPORT_RIS_LINE|EP|seitenzahl_ende}}' +
        '{{> EXPORT_RIS_LINE|UR|url}}' +
        '{{> EXPORT_RIS_LINE|LA|sprache.name_eng}}' +
        'ER  - \n' +
        '\n' +
        '{{< endswitch}}' +
    '{{/}}'
);

var DISPLAY_MARKUPS = {
    BASE_HREF () { return base_href; },
    DISPLAY_ACTION_MENU,
    DISPLAY_AUTHORS,
    DISPLAY_BERLIN_TIMESTAMP,
    DISPLAY_BUCHAUTORENSCHAFT,
    DISPLAY_BUCHBEITRAG,
    DISPLAY_BUCHHERAUSGEBERSCHAFT,
    DISPLAY_DETAILS_LINK,
    DISPLAY_EDITOR_LOG_ENTRY,
    DISPLAY_EDITOR_LOG_ROW_NEW,
    DISPLAY_EDITOR_LOG_ROW_OLD,
    DISPLAY_E_VEROEFFENTLICHUNG,
    DISPLAY_FORSCHUNGSPROJEKT,
    DISPLAY_FORSCHUNGSPROJEKTS,
    DISPLAY_HOCHSCHULSCHRIFT,
    DISPLAY_IGNORED_MESSAGES,
    DISPLAY_ISSN,
    DISPLAY_ITEM,
    DISPLAY_JOURNAL,
    DISPLAY_JOURNAL_ISSN,
    DISPLAY_JOURNALS,
    DISPLAY_JOURNAL_TITLE,
    DISPLAY_JSON_LIST,
    DISPLAY_KONGRESS_DURATION,
    DISPLAY_LIST,
    DISPLAY_LOG_IDLIST,
    DISPLAY_PATENTSCHRIFT,
    DISPLAY_POSTER,
    DISPLAY_PRESSESPIEGEL,
    DISPLAY_PRESSESPIEGEL_LIST,
    DISPLAY_PUBLICATION_TYPE_NAME,
    DISPLAY_PUBLICATION_TYPE_NAME_SINGLULAR,
    DISPLAY_REZENSION,
    DISPLAY_RUNDFUNK_FERNSEH_BEITRAG,
    DISPLAY_SEITEN_VON_BIS,
    DISPLAY_UNSORTED_LIST,
    DISPLAY_URL,
    DISPLAY_VORTRAG,
    DISPLAY_WHOLE_DATE,
    DISPLAY_WHOLE_TIME,
    DISPLAY_WISS_BEITRAG,
    DISPLAY_YEAR,
    DISPLAY_ZEITSCHRIFTENGERAUSGEBERSCHAFT,
    ESCAPE_DOUBLE_QUOTES_FOR_CSV,
    ESC_MOST_HTML,
    EXPORT_CSV,
    EXPORT_RIS,
    EXPORT_RIS_LINE,
    NO_RESULTS_YET,
    PATH_ROOT () { return path_root; },
    PATH_STATIC () { return path_static; },
    UPPER_QUOTE,

    console_log () {
        try {
            console.log.apply(console, arguments);
        } finally {
            return '';
        }
    },
};


/* *****************************************************************************
* DISPLAYING FUNCTIONS
*******************************************************************************/

var DEFAULT_DEST = '#pubdb_data';

function sort_by_authors_sortkey (aa, bb) {
    const empty = [];
    if (aa == null) {
        aa = empty;
    }
    if (bb == null) {
        bb = empty;
    }
    if (aa === bb) {
        return 0;
    }

    const length = max(aa.length, bb.length);
    for (let i = 0; i < length; ++i) {
        const a = aa[i];
        const b = bb[i];
        if (!a) {
            return -1;
        } else if (!b) {
            return +1;
        }

        const [a_sn, a_fn] = a;
        const [b_sn, b_fn] = b;
        if (a_sn < b_sn) {
            return -1;
        } else if (a_sn > b_sn) {
            return +1;
        } else if (a_fn < b_fn) {
            return -1;
        } else if (a_fn > b_fn) {
            return +1;
        }
    }
    return 0;
}

var ORDER_OF_TYPES = {
    wissenschaftlicher_beitrag: 0,
    buchautorenschaft: 1,
    buchbeitrag: 2,
    buchherausgeberschaft: 3,
    e_veroeffentlichung: 4,
    hochschulschrift: 5,
    patentschrift: 6,
    poster: 7,
    rezension: 8,
    rundfunk_fernseh_beitrag: 9,
    vortrag: 10,
    zeitschriftenherausgeberschaft: 11
};

function display_pressespiegel (json, dest) {
    return display_list(json, dest, DISPLAY_PRESSESPIEGEL_LIST);
}

function display_sorted_list(json, dest, markup, sort) {
    return display_list_ex(json, dest, markup || DISPLAY_LIST, sort ==/*sic*/ null ? true : sort);
}

function display_unsorted_list(json, dest, markup, sort) {
    return display_list_ex(json, dest, markup || DISPLAY_UNSORTED_LIST, sort ==/*sic*/ null ? false : sort);
}

function display_presorted_list(json, dest, markup) {
    return display_list_ex(json, dest, markup || DISPLAY_UNSORTED_LIST, false);
}

function display_list(json, dest, markup, sort) {
    if (typeof(sort) === 'string' && (sort !== '-')) {
        return display_presorted_list(json, dest, markup, sort);
    } else if (pubdb.unsorted_list) {
        return display_unsorted_list(json, dest, markup, sort);
    } else {
        return display_sorted_list(json, dest, markup, sort);
    }
}

function display_list_ex(json, dest, markup, sort) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }

    if (sort !== false) {
        var json_pubs = {};
        $(json).each(function(_, item) {
            item.jahr = new Date(item.datum).getUTCFullYear();
            json_pubs[item.id] = item;
        });

        var years = group(json, 'jahr', 0, 'year', {
            sort: function(a,b) {
                return b.year - a.year;
            }
        });

        var display_navigation = json.length > 5;

        $(years).each(function() {
            this.items = group(this.items, 'typ', undefined, 'type');
            this.items.sort(function (a, b) {
                return ORDER_OF_TYPES[a.type] - ORDER_OF_TYPES[b.type];
            });
            for (var i = 0; i < this.items.length; ++i) {
                this.items[i].items.sort(function (a, b) {
                    return sort_by_authors_sortkey(a.authors, b.authors)
                });
            }
            this.display_navigation = display_navigation && this.items.length > 1;
        });
    } else {
        years = json;
    }

    var html = mustache(markup || DISPLAY_LIST, {
        years: years,
        display_navigation: display_navigation && years.length > 1
    }, DISPLAY_MARKUPS);
    dest.html(html);
    next_tick(function () {
        var e = /^#?(PD_(?:year|item)_\d+(?:_[a-z_]+)?)/.exec(location.hash);
        if (e) {
            e = document.getElementById(e[1]);
            if (e) {
                e.scrollIntoView(true);
            }
        }
    });

    var action_extras = {
        scope_cb: function (selected_scope, selected_export) {},
        filename_cb: function (selected_export) {},
        data_cb: function (pubs_list, selected_export, selected_scope) {},
        dest: dest,
        actions: actions_go
    };

    $('.PD_actions_close', dest).click(function () {
        var self = $(this);
        next_tick(function () {
            actions_form.stop(true, true).hide(400);
        });
        return false;
    });

    var actions_go = $('.PD_actions_go', dest).empty()[0];
    if (actions_go) {
        action_extras.downloadify = downloadify_create(actions_go, {
            downloadImage: path_static + '/images/actions_button.png',
            title: false,
            filename: onButtonFilename,
            data: onButtonData,
            onError: onButtonError,
            height: 25,
            width: 87
        });
    }

    function onButtonError () {
        debugger; // TODO
    }

    var actions = $('.PD_actions', dest);
    var actions_form = $('form', actions).submit(function () {
        return false;
    });
    $('a:eq(0)', actions).click(function () {
        actions_form.stop(true, true).toggle(400);
        return false;
    });

    function userpage_action (pubs_list, selected_export, selected_scope) {
        function req_error (data, err, xhr) {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        }

        function success (resp) {
            if (!ajax_success_handler(resp)) {
                return;
            }

            const { data } = resp;
            const { affected_rows, count } = data;
            if (affected_rows === 0) {
                echo('confirm', 'Sämtliche Publikationen waren bereits in diesem Publikationsverzeichnis vorhanden.');
            } else {
                echo('confirm', 'Es wurden ' + affected_rows + ' Publikationen zu Ihrem Publikationsverzeichnis hinzugefügt.')
                const existed_counter = count - affected_rows;
                if (existed_counter) {
                    echo('confirm', existed_counter + ' Einträge waren bereits enthalten.');
                }
            }
        }

        if (pubs_list.type === 'pubs') {
            var pub_ids = map(pubs_list, p => p.id);
        } else {
            var pub_ids = [].slice.call(pubs_list, 0);
        }

        ajax_post(path_root + '/userpage/' + selected_export[1] + '/add/pubs/', {
            csrf_token: pubdb.csrf_token,
            pub_ids: pub_ids
        }, success, req_error);
    }

    function onButtonFilename () {
        var selected_export = $('[name="export-action"]:checked', actions_form).val().split(/-/g);
        return ({
            userpage: false,
            'export': function () {
                return {
                    'ris': 'Publikationsdatenbank.ris',
                    'csv': 'Publikationsdatenbank.csv',
                }[selected_export[1]];
            },
            details: false
        }[selected_export[0]] || function () {
            return action_extras.filename_cb(selected_export);
        })();
    }

    function export_action (pubs_list, selected_export, selected_scope) {
        return ({
            'ris': function () {
                try {
                    return mustache(EXPORT_RIS, {data:pubs_list});
                } catch (e) {
                    return '';
                }
            },
            'csv': function () {
                try {
                    return mustache(EXPORT_CSV, {data:pubs_list});
                } catch (e) {
                    return '';
                }
            },
        }[selected_export[1]] || noop)() || '';
    }

    function details_action (pubs_list, selected_export, selected_scope) {
        var new_win = open('about:blank', '_blank');

        function req_error (data, err, xhr) {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        }

        function success (data) {
            if (!data.success) {
                if ('login_required' in data.errors) {
                    relogin();
                } else if ('csrf_token' in data.errors) {
                    get_csrf_token();
                } else {
                    echo_errors(data.errors);
                }
                return;
            }

            next_tick(function () {
                new_win.document.firstChild.innerHTML = data.data;
            });
        }

        if (pubs_list.type === 'pubs') {
            var pub_ids = map(pubs_list, p => p.id);
        } else {
            var pub_ids = [].slice.call(pubs_list, 0);
        }
        ajax_post(path_root + '/pub/details/', { pub_ids: pub_ids }, success, req_error);
    }

    function onButtonData () {
        actions_form.stop(true, true).hide(400);

        var selected_export = $('[name="export-action"]:checked', actions_form).val().split(/-/g);
        var selected_scope = $('[name="export-scope"]:checked', actions_form).val();

        var pubs_list = ({
            'selected': function () {
                var results = []
                $('.PD_years input[type=checkbox]:checked', dest).each(function () {
                    var pd_item = $(this).parent();
                    var id = +(pd_item.data('pubid') || pd_item.attr('data-pubid'));
                    if (id) {
                        results.push(json_pubs[id]);
                    }
                });
                if (!results.length) {
                    return [];
                }
                results.type = 'pubs';
                return results;
            },

            'page': function () {
                var results = json.slice(0);
                results.type = 'pubs';
                return results;
            }
        }[selected_scope] || function () {
            return action_extras.scope_cb(selected_scope, selected_export);
        })();

        if (!pubs_list) {
            return '';
        }
        if (!pubs_list.length) {
            if (typeof $.fn.dialog === 'function') {
                confirm('Hinzufügen zu Benutzerseite',
                        'Sie haben keine Publikationen ausgewählt. ' +
                        'Bitte selektieren Sie zuerst eine oder mehrere Publikationen in dieser Liste ' +
                        'oder wählen Sie eine andere Option in „Anwenden auf“.',
                        [['OK']]);
            } else {
                next_tick(function () {
                    alert('Sie haben keine Publikationen ausgewählt. ' +
                         'Bitte selektieren Sie zuerst eine oder mehrere Publikationen in dieser Liste ' +
                         'oder wählen Sie eine andere Option in „Anwenden auf“.');
                });
            }
            return '';
        }

        return ({
            userpage: userpage_action,
            'export': export_action,
            details: details_action
        }[selected_export[0]] || function () {
            return action_extras.data_cb(pubs_list, selected_export, selected_scope);
        })(pubs_list, selected_export, selected_scope) || '';
    }

    return action_extras;
}

function display_pub(json, dest) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }
    json[0].jahr = new Date(json[0].datum).getUTCFullYear();
    dest.html(mustache(DISPLAY_ITEM, json[0], DISPLAY_MARKUPS));
}

function display_author(json, dest) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }
    $(json).each(function(_, item) {
        item.jahr = new Date(item.datum).getUTCFullYear();
    });

    // TODO
    $('<pre/>').text(stringify(json)).appendTo(dest);
}

function display_owner(json, dest) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html('<strong>Benutzer hat noch keine Publikationen eingetragen.</strong>');
        return;
    }
    return display_list(json, dest);
}

function display_forschungsprojekt(json, dest) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }

    json.beginn = json.beginn && new Date(json.beginn);
    json.ende = json.beginn && new Date(json.ende);

    dest.html(mustache(DISPLAY_FORSCHUNGSPROJEKT, {project:json}));
}


const normalize_for_sort_cache = Object.create(null);

function normalize_for_sort (s) {
    if (typeof(s) !== 'string') {
        return s;
    }

    let result = normalize_for_sort_cache[s];
    if (result == null) {
        result = (
            s.
            normalize('NFKD').
            replace(/ß/g, 'SS').
            replace(/[^\x00-\x7f]/g, '').
            toUpperCase().
            replace(/[^A-Z0-9]/g, ' ').
            replace(/(\d)([^ \d])/, '$1 $2').
            replace(/([^ \d])(\d)/, '$1 $2').
            replace(/(^| )0+(\d)/, '$1$2').
            trim().
            split(/ +/g).
            map(e => { let cp = e.charCodeAt(0); return (48 <= cp && cp <= 57) ? +e : e; })
        );
        normalize_for_sort_cache[s] = result;
    }
    return result;
}

function sort_title (a, b) {
    a = normalize_for_sort(a);
    b = normalize_for_sort(b);
    const l = max(a.length, b.length);
    for (let i = 0; i < l; ++i) {
        let ai = a[i];
        let bi = b[i];

        if (ai === bi) {
            continue;
        }

        if (ai == null) {
            return -1;
        } else if (bi == null) {
            return +1;
        }

        const ta = typeof(ai);
        const tb = typeof(bi);
        if (ta !== tb) {
            ai = ta;
            bi = tb;
        }
        return ai < bi ? -1 : +1;
    }
    return 0;
}

function smart_sort (a, b) {
    if (a === b) {
        return 0;
    }

    let ta = typeof(a);
    let tb = typeof(b);
    if ((ta !== tb || ta !== 'object') && (ta !== 'string' || tb !== 'string')) {
        if (a && b) {
            return a > b ? +1 : -1;
        } else {
            return a ? +1 : -1;
        }
    }

    return sort_title(a, b);
}


function display_forschungsprojekte (json, dest, sorted) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }

    for (let i = 0, {length} = json; i < length; ++i) {
        const json_i = json[i];
        json_i.abstract_ger = get_first_words(json_i.abstract_ger || '', 100);
        json_i.abstract_eng = get_first_words(json_i.abstract_eng || '', 100);

        json_i.beginn = json_i.beginn && new Date(json_i.beginn);
        json_i.ende = json_i.ende && new Date(json_i.ende);
    }

    if (!sorted) {
        const lang_key = (lang === 'en') ? 'sort_eng' : 'sort_ger';
        [].sort.call(
            json,
            (a, b) => smart_sort((a || {})[lang_key], (b || {})[lang_key])
        );
    }

    dest.html(mustache(DISPLAY_FORSCHUNGSPROJEKTS, {projects:json}));
}

function display_forschungsprojekte_sorted (json, dest) {
    return display_forschungsprojekte(json, dest, true);
}

function display_journal(json, dest) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }

    dest.html(mustache(DISPLAY_JOURNAL, {journal:json}));
    if (json[0].pubs && json[0].pubs.length) {
        display_list(json[0].pubs, $('<div/>').appendTo(dest));
    }
}

function display_journals(json, dest) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }

    const journals = $('<div>', { html: mustache(DISPLAY_JOURNALS, {journals:json}) });

    let keylist = document.createTextNode('');
    if (json.length > 5) {
        const children = journals.children();
        if (children.length > 1) {
            const key_sections = {};
            for (let i = 0, { length } = children; i < length; ++i) {
                const child = $(children[i]);
                key_sections[child.data('key')] = child;
            }

            keylist = $('<div>', {
                class: 'PD_section_links',
                style: 'margin-bottom:0.33em',
                append: $('<span>', {
                    append: $('<a>', {
                        text: 'alle',
                        attr: {
                            class: 'PD_section_links',
                            href: 'javascript:;',
                        },
                    }),
                    appendTo: keylist,
                }),
            });
            keylist.on('click', 'a', ev => {
                ev.preventDefault();
                try {
                    keylist.hide();
                    const key = $(ev.currentTarget).data('key');
                    for (const k in key_sections) {
                        const section = key_sections[k];
                        if (!key || k === key) {
                            section.show();
                        } else {
                            section.hide();
                        }
                    }
                } finally {
                    keylist.show();
                }
            });
            for (let key in key_sections) {
                $('<span>', {
                    append: $('<a>', {
                        text: key,
                        data: { key },
                        attr: {
                            class: 'PD_section_links',
                            href: 'javascript:;',
                        },
                    }),
                    appendTo: keylist,
                });
            }
        }
    }

    $('<div>', {
        class: 'PD_display_list',
        append: [keylist, journals],
        appendTo: dest.empty(),
    });
}

function display_fpkeywords (json, dest) {
    dest = $(dest || DEFAULT_DEST);
    if(!json || !json.length) {
        dest.html(NO_RESULTS_YET);
        return;
    }

    dest.html(mustache(DISPLAY_FPKEYWORDS, {fpkeywords:json}));
}

function toggle_diff (row, diff_fun) {
    row = $(row);
    var tds = row.children('td');
    switch (tds.length) {
        case 2: {
            tds = tds.add($('<td>', {
                colspan: 2,
                css: {
                    whiteSpace: 'pre-wrap',
                    display: 'none',
                },
                append: map(
                    diff_fun(tds[0].innerText, tds[1].innerText),
                    function (chunk) {
                        var wrapper = document.createElement('span');
                        var inner = document.createElement('span');
                        wrapper.style.color = '#999';

                        inner.style.whiteSpace = 'pre-wrap';
                        inner.style.color = '#000';

                        if (chunk.added) {
                            wrapper.style.backgroundColor = '#68fdd0';
                            wrapper.style.textDecoration = 'underline';
                            wrapper.style.padding = '0 0.5ex';
                        } else if (chunk.removed) {
                            wrapper.style.backgroundColor = '#ff9999';
                            wrapper.style.textDecoration = 'line-through';
                            wrapper.style.padding = '0 0.5ex';
                        }

                        inner.appendChild(document.createTextNode(chunk.value));
                        wrapper.appendChild(inner);

                        return wrapper;
                    }
                ),
                appendTo: row
            }));
            tds.toggle(0);
            break;
        }
        case 3: {
            tds.toggle(0);
            $(tds[2]).remove();
            break;
        }
    }
}



/*!
* mustache.js - Logic-less {{mustache}} templates with JavaScript
* http://github.com/janl/mustache.js
* License: MIT
*/

const escapeMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;'
};

function escapeHTML (s) {
    if (s != null) {
        return ('' + s).replace(/&(?!#x[\da-f]{1,8}|#\d{1,10}|[a-z]{1,24});|[<>"']/gi, s => escapeMap[s] || s);
    } else {
        return '';
    }
}

/**
 * Looks up the value of the given `name` in the given context `stack`.
 */
function lookup (name, stack, defaultValue) {
    if (name === ".") {
        return stack[stack.length - 1];
    }

    var names = name.split(".");
    if (names[0] === '~') {
        names.shift();
        stack = [window];
    }
    var lastIndex = names.length - 1;
    var target = names[lastIndex];

    var value, context, i = stack.length, j, localStack;
    while (i) {
        localStack = stack.slice(0);
        context = stack[--i];

        j = 0;
        while (j < lastIndex) {
            context = context[names[j++]];

            if (context == null) {
                break;
            }

            localStack.push(context);
        }

        if (context && typeof(context) === "object" && target in context) {
            value = context[target];
            break;
        }
    }

    // If the value is a function, call it in the current context.
    if (typeof(value) === "function") {
        value = value.call(localStack[localStack.length - 1]);
    }

    if (value == null)  {
        return defaultValue;
    }

    return value;
}

const mustache = (function () {
    const mustache_cache = Object.create(null);
    const { isArray } = Array;

    function renderSection (name, stack, callback, inverted) {
        let buffer = "";
        let value;
        if (!isArray(name)) {
            value =  lookup(name, stack);
        } else {
            for (let i = 0, { length } = name; i < length; ++i) {
                value = lookup(name[i], stack, '');
                if (value) {
                    break;
                }
            }
        }

        if (inverted) {
            // From the spec: inverted sections may render text once based on the
            // inverse value of the key. That is, they will be rendered if the key
            // doesn't exist, is false, or is an empty list.
            if (value == null || value === false || (isArray(value) && value.length === 0)) {
                buffer += callback();
            }
        } else if (isArray(value)) {
            [].forEach.call(value, function (value) {
                stack.push(value);
                buffer += callback();
                stack.pop();
            });
        } else if (typeof value === "object") {
            stack.push(value);
            buffer += callback();
            stack.pop();
        } else if (typeof value === "function") {
            const scope = stack[stack.length - 1];
            const scopedRender = (template) => render(template, scope);
            const result = value.call(scope, callback(), scopedRender);
            buffer += result != null ? '' + result : '';
        } else if (value) {
            buffer += callback();
        }

        return buffer;
    }

    /**
     * Parses the given `template` and returns the source of a function that,
     * with the proper arguments, will render the template.
     */
    function parse_template (template) {
        let openTag = '{{';
        let closeTag = '}}';

        var code = [
            '"use strict";' +
            'var buffer="";' + // output buffer
            'var orig_buffer="";' +
            'buffer+="'
        ];

        var spaces = [],      // indices of whitespace in code on the current line
            hasTag = false,   // is there a {{tag}} on the current line?
            nonSpace = false; // is there a non-space char on the current line?

        // Strips all space characters from the code array for the current line
        // if there was a {{tag}} on it and otherwise only spaces.
        function stripSpace () {
            if (hasTag && !nonSpace) {
                while (spaces.length) {
                    code.splice(spaces.pop(), 1);
                }
            } else {
                spaces = [];
            }

            hasTag = false;
            nonSpace = false;
        };

        var sectionStack = [], nextOpenTag, nextCloseTag;

        function includePartial (source) {
            var params = source.split('|');
            var source = params.shift();
            code.push(
                '";' +
                'var partial=partials["' + trim(source) + '"];' +
                'if(partial){'
            );

            if(params.length > 0) {
                code.push(
                    'buffer+=render(partial,stack[stack.length-1],extend({},partials,{args:' + stringify(params) + '}));'
                );
            } else {
                code.push('buffer+=render(partial,stack[stack.length-1],partials);');
            }
            code.push(
                '}' +
                'buffer+="'
            );
        }

        function conditionalSection (source) {
            var s = /^\s*(if|elif)\s+(\S+)\s+(\S+)\s+(\S+)\s*$/.exec(source);
            code.push('";');
            if(!s) {
                code.push(
                    'return buffer;' +
                    '});' +
                    '}else if(1){' +
                    'callback=(function(orig_buffer){' +
                    'var buffer="";'
                );
                if(/else/i.exec(source)) {
                    ;
                } else if(/endif/i.exec(source)) {
                    code.push(
                        'return buffer;' +
                        '});' +
                        '}' +
                        'return callback(buffer||orig_buffer);' +
                        '})(buffer||orig_buffer);'
                    );
                } else {
                    throw Error('Illegal pattern');
                }
            } else {
                var l = !/["']/.exec(s[2][0]) ? 'lookup("' + s[2] + '", stack, "")' : s[2];
                var r = !/["']/.exec(s[4][0]) ? 'lookup("' + s[4] + '", stack, "")' : s[4];
                var test = '('+l+') ' + s[3] + ' ('+r+')';

                if(s[1] === 'if') {
                    code.push(
                        'buffer+=(function(orig_buffer){' +
                        'var callback;'
                    );
                } else if(s[1] === 'elif') {
                    code.push(
                        'return buffer;' +
                        '});' +
                        '}else '
                    );
                } else {
                    throw new Error('s[1] = ' + s[1]);
                }

                code.push(
                    'if(' + test + '){' +
                    'callback=(function(orig_buffer){' +
                    'var buffer="";'
                );
            }
            code.push('buffer+="');
        }

        function openSection (source, inverted) {
            var name = trim(source);
            var names = map(name.split(/\|/g), function (s) {
                return '"'+ trim(s) + '"';
            }).join(',');

            if (name === "") {
                throw Error('Section name may not be empty');
            }

            sectionStack.push({inverted});

            code.push(
                '";' +
                'var names=[' + names + '];' +
                'var callback=(function(orig_buffer){' +
                'return function(){' +
                'var buffer="";' +
                'buffer+="'
            );
        }

        function openInvertedSection (source) {
            openSection(source, true);
        }

        function closeSection () {
            var section = sectionStack.pop();

            code.push(
                '";' +
                'return buffer;' +
                '};' +
                '})(buffer||orig_buffer);'
            );

            if (section.inverted) {
                code.push("\nbuffer+=renderSection(names,stack,callback,true);");
            } else {
                code.push("\nbuffer+=renderSection(names,stack,callback);");
            }

            code.push(' buffer+="');
        }

        function sendPlain (source) {
            code.push(
                '";' +
                'buffer+=lookup("' + trim(source) + '",stack,"");' +
                'buffer+="'
            );
        };

        function sendEscaped (source) {
            code.push(
                '";' +
                'buffer+=escapeHTML(lookup("' + trim(source) + '",stack,""));' +
                'buffer+="'
            );
        }

        function switchSection (source) {
            var e = /^\s*(?:(?:switch\s+(.+?))|(?:case\s+(.*?))|(endswitch))\s*$/i.exec(source);
            if (!e) {
                throw Error('"switch" or "case" or "endswitch" statement expected');
            }
            if (e[1]) { // switch
                var fields = map(e[1].split(/\|/g), function (f) {
                    return 'lookup("' + f + '",stack,"")';
                }).join(' || ');
                code.push(
                    '";' +
                    'switch(String(' + fields + ')){' +
                    'default:' +
                    'buffer+="'
                );
            } else if (e[3]) { // endswitch
                code.push(
                    '";' +
                    '}' +
                    'buffer+="'
                );
            } else { // case, e[2] might be empty in IE (as in ""), instead of undefined!
                code.push(
                    '";' +
                    'break;' +
                    'case("' + e[2].replace(/"\\/g, '\\$1') + '"):' +
                    'buffer+="'
                );
            }
        }

        function conditionalDot (source) {
            code.push(
                '";' +
                'if (!/([,.-;:!?]|<\\/?(br|div|p)\\s*\\/?\\s*>)\\s*$/.exec(buffer||orig_buffer)) {' +
                'buffer+=' + (trim(source) || '"."') + ';' +
                '}' +
                'buffer+="'
            );
        }

        function escapeSection (source) {
            source = trim(source);
            if (source) {
                code.push(
                    '";' +
                    'buffer+=partials["' + source + '"]((function(orig_buffer){' +
                    'buffer+="'
                );
            } else {
                code.push(
                    '";' +
                    'return buffer;' +
                    '})(buffer||orig_buffer));' +
                    'buffer+="'
                );
            }
        }

        var c, callback;
        for (var i = 0, len = template.length; i < len; ++i) {
            if (template.slice(i, i + openTag.length) === openTag) {
                i += openTag.length;
                c = template.substr(i, 1);
                nextOpenTag = openTag;
                nextCloseTag = closeTag;
                hasTag = true;

                switch (c) {
                case "!": // comment
                    i++;
                    callback = null;
                    break;
                case ">": // include partial
                    i++;
                    callback = includePartial;
                    break;
                case "#": // start section
                    i++;
                    callback = openSection;
                    break;
                case "^": // start inverted section
                    i++;
                    callback = openInvertedSection;
                    break;
                case "/": // end section
                    i++;
                    callback = closeSection;
                    break;
                case "{": // plain variable
                    closeTag = "}" + closeTag;
                    // fall through
                case "&": // plain variable
                    i++;
                    nonSpace = true;
                    callback = sendPlain;
                    break;
                case "-": // test
                    i++;
                    callback = conditionalSection;
                    break;
                case "<": // switch
                    i++;
                    callback = switchSection;
                    break;
                case ".": // conditinal fullstop
                    i++;
                    callback = conditionalDot;
                    break;
                case "`": // escape section
                    i++;
                    callback = escapeSection;
                    break;
                default: // escaped variable
                    nonSpace = true;
                    callback = sendEscaped;
                }

                var end = template.indexOf(closeTag, i);

                if (end === -1) {
                    throw Error('Tag was not closed properly');
                }

                var source = template.substring(i, end);

                if (callback) {
                    callback(source);
                }

                i = end + closeTag.length - 1;
                openTag = nextOpenTag;
                closeTag = nextCloseTag;
            } else {
                c = template.substr(i, 1);

                switch (c) {
                case '"':
                case "\\":
                    nonSpace = true;
                    code.push("\\" + c);
                    break;
                case "\r":
                    // Ignore carriage returns.
                    break;
                case "\n":
                    spaces.push(code.length);
                    code.push("\\n");
                    stripSpace(); // Check for whitespace on the current line.
                    break;
                default:
                    if (/^\s*$/.exec(c)) {
                        spaces.push(code.length);
                    } else {
                        nonSpace = true;
                    }

                    code.push(c);
                }
            }
        }

        if (sectionStack.length != 0) {
            throw Error('Section was not closed properly');
        }

        // Clean up any whitespace from a closing {{tag}} that was at the end
        // of the template without a trailing \n.
        stripSpace();

        code.push(
            '";'+ 
            'return buffer;'
        );

        // Ignore `buffer += "";` statements.
        return code.join('').replace(/\s*buffer\s*\+=\s*"";\s*/g, ' ').replace(/ {2,}/, ' ');
    }

    /**
     * Used by `compile` to generate a reusable function for the given `template`.
     */
    function _compile (template) {
        return Function(
            "view,partials,stack,lookup,escapeHTML,renderSection,render,extend",
            parse_template(template)
        );
    }

    /**
     * Compiles the given `template` into a reusable function.
     */
    function compile (template) {
        var fn;
        if (typeof template === 'function') {
            fn = template;
        } else if (mustache_cache[template]) {
            fn = mustache_cache[template];
        } else {
            fn = mustache_cache[template] = _compile(template, {});
        }
        return function (view, partials) {
            var stack = [view]; // context stack
            return fn.call(view, view, partials, stack, lookup, escapeHTML, renderSection, render, extend);
        };
    }

    /**
     * High-level function that renders the given `template` using the given
     * `view` and `partials`. If you need to use any of the template options (see
     * `compile` above), you must compile in a separate step, and then call that
     * compiled function.
     */
    function render (template, view, partials) {
        return compile(template)(view, partials || DISPLAY_MARKUPS);
    }

    render.render = render;
    return render;
}());


const md5 = function () {
    function md5cycle(x, k) {
        var a = x[0],
                b = x[1],
                c = x[2],
                d = x[3];

        a = ff(a, b, c, d, k[0], 7, - 680876936);
        d = ff(d, a, b, c, k[1], 12, - 389564586);
        c = ff(c, d, a, b, k[2], 17, 606105819);
        b = ff(b, c, d, a, k[3], 22, - 1044525330);
        a = ff(a, b, c, d, k[4], 7, - 176418897);
        d = ff(d, a, b, c, k[5], 12, 1200080426);
        c = ff(c, d, a, b, k[6], 17, - 1473231341);
        b = ff(b, c, d, a, k[7], 22, - 45705983);
        a = ff(a, b, c, d, k[8], 7, 1770035416);
        d = ff(d, a, b, c, k[9], 12, - 1958414417);
        c = ff(c, d, a, b, k[10], 17, - 42063);
        b = ff(b, c, d, a, k[11], 22, - 1990404162);
        a = ff(a, b, c, d, k[12], 7, 1804603682);
        d = ff(d, a, b, c, k[13], 12, - 40341101);
        c = ff(c, d, a, b, k[14], 17, - 1502002290);
        b = ff(b, c, d, a, k[15], 22, 1236535329);

        a = gg(a, b, c, d, k[1], 5, - 165796510);
        d = gg(d, a, b, c, k[6], 9, - 1069501632);
        c = gg(c, d, a, b, k[11], 14, 643717713);
        b = gg(b, c, d, a, k[0], 20, - 373897302);
        a = gg(a, b, c, d, k[5], 5, - 701558691);
        d = gg(d, a, b, c, k[10], 9, 38016083);
        c = gg(c, d, a, b, k[15], 14, - 660478335);
        b = gg(b, c, d, a, k[4], 20, - 405537848);
        a = gg(a, b, c, d, k[9], 5, 568446438);
        d = gg(d, a, b, c, k[14], 9, - 1019803690);
        c = gg(c, d, a, b, k[3], 14, - 187363961);
        b = gg(b, c, d, a, k[8], 20, 1163531501);
        a = gg(a, b, c, d, k[13], 5, - 1444681467);
        d = gg(d, a, b, c, k[2], 9, - 51403784);
        c = gg(c, d, a, b, k[7], 14, 1735328473);
        b = gg(b, c, d, a, k[12], 20, - 1926607734);

        a = hh(a, b, c, d, k[5], 4, - 378558);
        d = hh(d, a, b, c, k[8], 11, - 2022574463);
        c = hh(c, d, a, b, k[11], 16, 1839030562);
        b = hh(b, c, d, a, k[14], 23, - 35309556);
        a = hh(a, b, c, d, k[1], 4, - 1530992060);
        d = hh(d, a, b, c, k[4], 11, 1272893353);
        c = hh(c, d, a, b, k[7], 16, - 155497632);
        b = hh(b, c, d, a, k[10], 23, - 1094730640);
        a = hh(a, b, c, d, k[13], 4, 681279174);
        d = hh(d, a, b, c, k[0], 11, - 358537222);
        c = hh(c, d, a, b, k[3], 16, - 722521979);
        b = hh(b, c, d, a, k[6], 23, 76029189);
        a = hh(a, b, c, d, k[9], 4, - 640364487);
        d = hh(d, a, b, c, k[12], 11, - 421815835);
        c = hh(c, d, a, b, k[15], 16, 530742520);
        b = hh(b, c, d, a, k[2], 23, - 995338651);

        a = ii(a, b, c, d, k[0], 6, - 198630844);
        d = ii(d, a, b, c, k[7], 10, 1126891415);
        c = ii(c, d, a, b, k[14], 15, - 1416354905);
        b = ii(b, c, d, a, k[5], 21, - 57434055);
        a = ii(a, b, c, d, k[12], 6, 1700485571);
        d = ii(d, a, b, c, k[3], 10, - 1894986606);
        c = ii(c, d, a, b, k[10], 15, - 1051523);
        b = ii(b, c, d, a, k[1], 21, - 2054922799);
        a = ii(a, b, c, d, k[8], 6, 1873313359);
        d = ii(d, a, b, c, k[15], 10, - 30611744);
        c = ii(c, d, a, b, k[6], 15, - 1560198380);
        b = ii(b, c, d, a, k[13], 21, 1309151649);
        a = ii(a, b, c, d, k[4], 6, - 145523070);
        d = ii(d, a, b, c, k[11], 10, - 1120210379);
        c = ii(c, d, a, b, k[2], 15, 718787259);
        b = ii(b, c, d, a, k[9], 21, - 343485551);

        x[0] = add32(a, x[0]);
        x[1] = add32(b, x[1]);
        x[2] = add32(c, x[2]);
        x[3] = add32(d, x[3]);
    }

    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32((a << s) | (a >>> (32 - s)), b);
    }

    function ff(a, b, c, d, x, s, t) {
        return cmn((b & c) | ((~b) & d), a, b, x, s, t);
    }

    function gg(a, b, c, d, x, s, t) {
        return cmn((b & d) | (c & (~d)), a, b, x, s, t);
    }

    function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
    }

    function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | (~d)), a, b, x, s, t);
    }

    function md51(s) {
        var n = s.length,
                state = [1732584193, - 271733879, - 1732584194, 271733878],
                i;
        for (i = 64; i <= s.length; i += 64) {
            md5cycle(state, md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < s.length; i++)
        tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for (i = 0; i < 16; i++)
                tail[i] = 0;
        }
        tail[14] = n * 8;
        md5cycle(state, tail);
        return state;
    }

    function md5blk(s) { /* I figured global was faster.   */
        var md5blks = [];
        for (var i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
    }

    var hex_chr = '0123456789abcdef'.split('');

    function rhex(n) {
        var s = '',
                j = 0;
        for (; j < 4; j++)
            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F];
        return s;
    }

    function hex(x) {
        for (var i = 0; i < x.length; i++)
            x[i] = rhex(x[i]);
        return x.join('');
    }

    function md5(s) {
        return hex(md51(s));
    }

    function add32(a, b) {
        return (a + b) | 0;
    }

    return md5;
}();


/**
Downloadify: Client Side File Creation
JavaScript + Flash Library

Version: 0.2

Copyright (c) 2009 Douglas C. Neiner

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

var downloadify_create = (function () {
    var uid0 = new Date().getTime();
    var uid1 = 0;

    var queues = Object.create(null);

    pubdb.downloadify = {
        getTextForSave: function (queue_name) {
            var obj = queues[queue_name];
            if (obj) return obj.getData();
            return "";
        },
        getFileNameForSave: function (queue_name) {
            var obj = queues[queue_name];
            if (obj) return obj.getFilename();
            return "";
        },
        saveComplete: function (queue_name) {
            var obj = queues[queue_name];
            if (obj) obj.complete();
            return true;
        },
        saveCancel: function (queue_name) {
            var obj = queues[queue_name];
            if (obj) obj.cancel();
            return true;
        },
        saveError: function (queue_name) {
            var obj = queues[queue_name];
            if (obj) obj.error();
            return true;
        }
    };

    function Container(el, options) {
        this.el = document.createElement('span');
        this.el.style.cursor = 'pointer';
        this.el.style.padding = this.el.style.margin = '0';
        if (options.title) {
            this.el.title = options.title;
        }
        el.appendChild(this.el);

        var dest_el = document.createElement('span');
        this.dest_el = dest_el;
        this.el.appendChild(dest_el);

        this.options = options;
        this.queue_name = dest_el.id = '_PubDB_' + uid0 + '_' + ++uid1 + '_'

        if (typeof (options.filename) === "function") {
            this.filenameCallback = options.filename;
        } else if (options.filename) {
            this.filename = options.filename;
        }

        if (typeof (options.data) === "function") {
            this.dataCallback = options.data;
        } else if (options.data) {
            this.data = options.data;
        }
    }
    Container.prototype = {
        getData: function () {
            if (this.dataCallback) return this.dataCallback();
            else if (this.data) return this.data;
            else return "";
        },
        getFilename: function () {
            if (this.filenameCallback) return this.filenameCallback();
            else if (this.filename) return this.filename;
            else return "";
        },
        complete: function () {
            if (typeof (this.options.onComplete) === "function") this.options.onComplete();
        },
        cancel: function () {
            if (typeof (this.options.onCancel) === "function") this.options.onCancel();
        },
        error: function () {
            if (typeof (this.options.onError) === "function") this.options.onError();
        }
    };

    return function (el, options) {
        var base = new Container(el, options);

        var img = $('<img/>').attr({
            src: options.downloadImage,
            alt: ''
        }).css({
            padding: 0,
            margin: 0,
            border: 0
        })
        var link = $('<a/>').attr({
            href: 'javascript:void(0)'
        }).css({
            padding: 0,
            margin: 0,
            border: 0,
            'text-decoration': 'none !important',
            cursor: 'pointer',
            'text-align': 'center'
        }).append(img).appendTo(base.dest_el).click(function () {
            link.attr({
                href: 'javascript:void(0)',
                download: ''
            });

            var title = pubdb.downloadify.getFileNameForSave(base.queue_name);
            var data = pubdb.downloadify.getTextForSave(base.queue_name);
            if (!title || !data) {
                return false;
            }

            var blob = new Blob([data], { type: 'text/plain' });
            var url = URL.createObjectURL(blob);
            link.attr({
                href: url,
                download: title
            });

            if (typeof link.one === 'function') {
                link.one('click', function () {
                    next_tick(function () {
                        URL.revokeObjectURL(url);
                    });
                });
            }
        });

        queues[base.queue_name] = base;
        return base;
    };
})();



/* *****************************************************************************
* LIBARY INTERFACE
*******************************************************************************/

if (pubdb.no_content_only === null) {
    $(function() {
        // does no bad if included twice
        $('<link/>').attr({
            href: path_static + '/css/style.css',
            rel: 'stylesheet',
            type: 'text/css'
        }).appendTo($('head'));
    });
}

$(function() {
    $('#PubDB form').attr('accept-charset', 'UTF-8');
    $('#PubDB').on('form', 'submit', ev => { $(this).attr('accept-charset', 'UTF-8'); });
});


let dom_ready = false;
$(() => { dom_ready = true; });

function display_when_ready(fn) {
    return function() {
        if (dom_ready) {
            let v = null;
            let e = null;
            try {
                v = fn.apply(this, arguments);
            } catch (ex) {
                e = ex;
                console.log('Caught exception in display_when_ready', { fn, ex });
            }
            return [v, e];
        }

        const self = this;
        const args = [].slice.call(arguments, 0);
        const result = [];
        $(function () {
            let v = null;
            let e = null;
            try {
                v = fn.apply(self, args);
            } catch (ex) {
                e = ex;
                console.log('Caught exception in display_when_ready', { fn, ex });
            }
            result.push(v, e);
        });
        return result;
    };
}


(function () {
    function use_piwik () {
        if (done) {
            return;
        }

        const { Piwik } = window;

        if (!Piwik) {
            setTimeout(use_piwik, 50);
            return;
        }
        done = true;

        try {
            const piwik_tracker = Piwik.getTracker(base_href + '/piwik/piwik.php', 1);
            pubdb.piwik_tracker = piwik_tracker;
            piwik_tracker.trackPageView();
            piwik_tracker.enableLinkTracking();
        } catch (e) {
            // void
        }
    }

    var head = document.getElementsByTagName("head")[0] || document.documentElement;
    var s = document.createElement('script');
    s.async = true;
    s.defer = true;
    s.src = base_href + '/piwik/piwik.js';
    s.onload = use_piwik;
    s.onerror = (function () {
        done = true;
        pubdb.piwik_tracker = {
            trackPageView: noop,
        };
    });
    head.appendChild(s);

    var done = false;
    use_piwik();
})();

function track_view (title) {
    if (pubdb.piwik_tracker) {
        try {
            pubdb.piwik_tracker.trackPageView(title);
        } catch (e) {
            // void
        }
    }
}

var embed_initialized = false;
function init_for_embed (h1, dest, next) {
    h1 = h1 ? $(h1) : [];
    if (!embed_initialized && h1.length) {
        embed_initialized = true;
        var languages = $('<div/>', {
            id: 'languages',
            css: {
                clear: 'right',
                'float': 'right'
            }
        });

        echo_dest = $('<ul/>', {
            'class': 'noprint',
            id: 'echo'
        });
        $('<div/>', {
            'class': 'PubDB'
        }).append(echo_dest).insertAfter(h1);

        if (!pubdb.has_menu) {
            if (!login_details) {
                next = next ? '?next=' + encode_uri_component(path_root + next) : '';
                languages.append(
                    $('<a/>', {
                        'class': 'lang_link',
                        href: path_root + '/login/' + next
                    }).text('einloggen'),
                    ' | ',
                    $('<a/>', {
                        'class': 'lang_link',
                        href: path_root + '/user/new/'
                    }).text('registrieren')
                );
            } else {
                languages.append(
                    $('<a/>', {
                        'class': 'lang_link',
                        href: path_root + '/user/' + login_details.id + '/'
                    }).text(login_details.account_name),
                    ' | ',
                    $('<a/>', {
                        'class': 'lang_link',
                        href: path_root + '/logout/'
                    }).text('abmelden'),
                    ' | ',
                    $('<a/>', {
                        'class': 'lang_link',
                        href: 'mailto:pubdb@library.vetmed.fu-berlin.de'
                    }).text('Feedback')
                );
            }
            languages.append(' | ', $('<a/>', {
                title: 'Zur Startseite der Publikationsdatenbank gehen.',
                href: path_root + '/'
            }).append($('<img/>', {
                src: base_href + '/static/icons/circular_icons/home.png',
                alt: 'Zur Startseite der Publikationsdatenbank gehen.',
                css: {
                    'vertical-align': 'top'
                }
            }), document.createTextNode(' Startseite'))).insertBefore(h1);

            if (login_details) {
                languages.prepend(
                    $('<a/>', {
                        'class': 'lang_link',
                        href: path_root + '/user/' + encode_uri_component(login_details.account_name) + '/'
                    }).append($('<img/>', {
                        title: 'Sie sind angemeldet als ' + login_details.account_name,
                        css: {
                            'margin-top': '-3px',
                            'vertical-align': 'top'
                        },
                        src: base_href + '/gravatar/' + md5(login_details.mail) + '?s=22&d=identicon&r=pg',
                        alt: ''
                    })),
                    ' '
                );
            }
        }
    }

    var res = $('<div/>', {
        'class': 'PubDB',
        style: 'width: 100%'
    }).append($('<ul/>', {
        id: 'echo',
        'class': 'noprint'
    })).append($('<div/>', {
        id: 'pubdb_data'
    }).append($('<div/>', {
        'class': 'throbber'
    })));
    $(dest).replaceWith(res);
    return res;
}

$(function () {
    $('#start_menu div div').hover(function () {
        var self = $(this);
        next_tick(function () {
            self.css('text-decoration', 'underline');
        });
    }, function () {
        var self = $(this);
        next_tick(function () {
            self.css('text-decoration', '');
        });
    })
});


if (fn_tooltip !== noop) {
    // Add tooltip for ISSNs

    $(document).on('mouseenter', '.pubdb-issn-link', function (ev) {
        const self = $(this);
        self.removeClass('pubdb-issn-link');

        var container = self.wrap('<span/>').parent();

        const hover = $('<div/>', {
            append: $('<iframe/>', {
                attr: {
                    src: self.attr('href') + '?base_target=blank&content_only',
                    seamless: 'seamless',
                    scrolling: 'no',
                },
                css: {
                    height: '18rem',
                    width: '25rem',
                    border: '1px solid #333',
                    overflow: 'hidden',
                    fontSize: '14px',
                },
            }),
            attr: {
                class: 'tooltip',
                style: 'font-size:1.35rem;line-height:1.5rem;pointer-events:unset;background:#ddd;color:#000;font-weight:normal',
            },
            appendTo: container,
        });

        self.data('pubdb-tooltip', { questionmark: self, hover });

        activate_tooltips(self, null, 5);

        self.data('tooltip').show();
    });

    // Activate static tooltips

    $(document).on('mouseenter', '.pubdb-tooltipped', function (ev) {
        const container = $(this);
        container.removeClass('pubdb-tooltipped');
        const { tooltip_rel, tooltip_px } = container.data() || {};

        const children = container.children();
        const self = $(children[0]);
        const tooltip = $(children[1]);

        const hover = $('<div/>', {
            append: tooltip,
            attr: { class: 'tooltip' },
            appendTo: container,
        });
        self.data('pubdb-tooltip', { questionmark: self, hover });
        activate_tooltips(self, tooltip_rel, tooltip_px);

        tooltip.show();
        self.data('tooltip').show();
    });
}


$(function () {
    // Logout without an intermediate page

    $('#PubDB-Body, .PubDB-Body').find('.services a[href$="/logout/"]').one('click', function (ev) {
        $('<form/>', {
            attr: {
                method: 'post',
                action: this.href,
            },
            append: $('<input>', {
                attr: {
                    type: 'hidden',
                    name: 'csrf_token',
                    value: pubdb.csrf_token,
                },
            }),
            appendTo: 'body',
        }).submit();

        ev.preventDefault();
    });
});


// remove "?nocache=..." from query search


function without_nocache (old_search) {
    if (!old_search) {
        return [false, ''];
    }

    const m = /^(.*?)(^[?]?|&)nocache=[^&]*(&?)(.*)$/.exec(old_search);
    if (!m) {
        return [false, (old_search[0] === '?' ? old_search : '?' + old_search)];
    }

    const [, before, sep1, sep2, after] = m;
    if (!before && !after) {
        return [true, ''];
    }

    let new_search;
    if (!after) {
        new_search = before;
    } else if (!before) {
        new_search = sep1 + after;
    } else {
        new_search = before + sep2 + after;
    }

    if (new_search && (new_search[0] !== '?')) {
        new_search = '?' + new_search;
    }
    return [true, new_search];
}


next_tick(function () {
    if (history && (typeof(history.replaceState) === 'function')) {
        const [changed, new_search] = without_nocache(location.search);
        if (changed) {
            history.replaceState(null, document.title, location.pathname + new_search);
        }
    }
});


pubdb.$ = $;
pubdb.add_html_tooltip = add_html_tooltip;
pubdb.add_toggle_diff = add_toggle_diff;
pubdb.ajax_get = ajax_get;
pubdb.ajax_post = ajax_post;
pubdb.ajax_success_handler = ajax_success_handler;
pubdb.ajax_success_next_handler = ajax_success_next_handler;
pubdb.confirm = confirm;
pubdb.copy_obj = copy_obj;
pubdb.date_berlin = date_berlin;
pubdb.debounce = debounce;
pubdb.decode_uri_component = decode_uri_component;
pubdb.decr_ajax_wait = decr_ajax_wait;
pubdb.DISPLAY_MARKUPS = DISPLAY_MARKUPS;
pubdb.display_when_ready = display_when_ready;
pubdb.document = document;
pubdb.downloadify_create = downloadify_create;
pubdb.echo = echo;
pubdb.echo_errors = echo_errors;
pubdb.encodeBooleanSearch = encodeBooleanSearch;
pubdb.encode_uri_component = encode_uri_component;
pubdb.extend = extend;
pubdb.foreach_key = foreach_key;
pubdb.get_csrf_token = get_csrf_token;
pubdb.get_nice_publication_type_name = get_nice_publication_type_name;
pubdb.group = group;
pubdb.groupToMap = groupToMap;
pubdb.hasRole = hasRole;
pubdb.iframe_dialog = iframe_dialog;
pubdb.incr_ajax_wait = incr_ajax_wait;
pubdb.indexOf = indexOf;
pubdb.kb_ev_cmp = kb_ev_cmp;
pubdb.kb_ev_enter = kb_ev_enter;
pubdb.kb_ev_up_down_enter = kb_ev_up_down_enter;
pubdb.list_keys = list_keys;
pubdb.list_values = list_values;
pubdb.map = map;
pubdb.mark_erroneous = mark_erroneous;
pubdb.md5 = md5;
pubdb.moment = moment;
pubdb.multi_prompt = multi_prompt;
pubdb.mustache = mustache;
pubdb.next_tick = next_tick;
pubdb.parse_qsl = parse_qsl;
pubdb.parse_qs = parse_qs;
pubdb.prompt = prompt;
pubdb.pubdb = pubdb;
pubdb.range = range;
pubdb.read_form_data = read_form_data;
pubdb.relogin = relogin;
pubdb.resizable_dialog = resizable_dialog;
pubdb.smart_sort = smart_sort;
pubdb.sort_by_key = sort_by_key;
pubdb.sort_title = sort_title
pubdb.status_call1 = status_call1;
pubdb.status_call = status_call;
pubdb.status_otf = status_otf;
pubdb.status_ping = status_ping;
pubdb.toggle_diff = toggle_diff;
pubdb.track_view = track_view;
pubdb.trim = trim;
pubdb.urlencode = urlencode;
pubdb.window = window;
pubdb.without_nocache = without_nocache;

pubdb.activate_tooltips = display_when_ready(activate_tooltips);
pubdb.add_tooltip = display_when_ready(add_tooltip);
pubdb.display_author = display_when_ready(display_author);
pubdb.display_forschungsprojekt = display_when_ready(display_forschungsprojekt);
pubdb.display_forschungsprojekte = display_when_ready(display_forschungsprojekte);
pubdb.display_forschungsprojekte_sorted = display_when_ready(display_forschungsprojekte_sorted);
pubdb.display_fpkeywords = display_when_ready(display_fpkeywords);
pubdb.display_journal = display_when_ready(display_journal);
pubdb.display_journals = display_when_ready(display_journals);
pubdb.display_list = display_when_ready(display_list);
pubdb.display_list_ex = display_when_ready(display_list_ex);
pubdb.display_owner = display_when_ready(display_owner);
pubdb.display_presorted_list = display_when_ready(display_presorted_list);
pubdb.display_pressespiegel = display_when_ready(display_pressespiegel);
pubdb.display_pub = display_when_ready(display_pub);
pubdb.display_sorted_list = display_when_ready(display_sorted_list);
pubdb.display_unsorted_list = display_when_ready(display_unsorted_list);
pubdb.init_for_embed = display_when_ready(init_for_embed);
pubdb.make_datepicker = display_when_ready(make_datepicker);
pubdb.review_filter_years = display_when_ready(review_filter_years);
pubdb.review_sortable = display_when_ready(review_sortable);
